export default function RenderImage() {
  return (
    <svg
      width="211"
      height="220"
      viewBox="0 0 211 220"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        d="M17.291 205.072L136.378 139.077V61.3535L17.291 127.348V205.072Z"
        fill="#F4F6FC"
      />
      <path
        d="M17.2903 127.485L136.377 61.3531V59.1006L14.998 126.469L15.1618 203.822L17.2903 205.072V127.485Z"
        fill="#E4E6F3"
      />
      <path
        d="M207.709 178.125L136.377 139.077V61.3535L207.709 100.415V178.125Z"
        fill="#DADDE9"
      />
      <path
        d="M207.709 100.539L136.377 61.354V59.1016L210.001 99.5224L209.837 176.875L207.709 178.125V100.539Z"
        fill="#E2E5F1"
      />
      <path
        d="M17.2891 145.971L136.376 79.9767V2.2666L17.2891 68.2474V145.971Z"
        fill="#F4F6FC"
      />
      <path
        d="M17.2903 68.3844L136.377 2.2662V0L14.998 67.368L15.1618 144.721L17.2903 145.971V68.3844Z"
        fill="#E4E6F3"
      />
      <path
        d="M207.709 119.024L136.377 79.9768V2.2666L207.709 41.314V119.024Z"
        fill="#DADDE9"
      />
      <path
        d="M207.709 41.4372L136.377 2.2662V0L210.001 40.4208L209.837 117.774L207.709 119.024V41.4372Z"
        fill="#E2E5F1"
      />
      <path
        d="M142.095 166.313C142.095 166.313 139.543 166.285 138.083 166.313C136.623 166.34 134.754 167.04 134.686 168.112C134.618 169.183 135.095 170.007 136.542 171.01C137.988 172.012 138.629 172.534 140.526 172.534C142.422 172.534 143.336 172.63 144.1 173.331C144.851 174.018 145.383 175.089 146.761 175.432C148.139 175.776 150.691 175.57 151.195 173.908L150.677 171.106L142.095 166.299V166.313Z"
        fill="#13130A"
      />
      <path
        d="M134.686 168.538C134.768 169.417 135.286 170.145 136.528 171.01C137.974 172.013 138.615 172.535 140.512 172.535C142.409 172.535 143.323 172.631 144.087 173.331C144.837 174.018 145.369 175.089 146.747 175.433C148.085 175.762 150.513 175.584 151.127 174.059L151.182 174.375C151.182 174.375 151.141 174.499 151.114 174.554L151.182 174.952C150.663 176.614 148.126 176.82 146.747 176.477C145.369 176.133 144.837 175.062 144.087 174.362C144.087 174.362 144.087 174.362 144.073 174.362L144.155 173.867C144.155 173.867 144.114 173.826 144.087 173.798C143.336 173.112 142.409 173.002 140.512 173.002C138.615 173.002 137.974 172.48 136.528 171.477C135.082 170.475 134.604 169.651 134.672 168.579V168.552L134.686 168.538Z"
        fill="#13130A"
      />
      <path
        d="M142.818 155.984C142.818 155.984 142.231 164.802 141.399 166.793C141.399 166.793 140.635 168.593 143.064 170.488C145.847 172.672 150.923 171.807 150.923 171.807L152.219 161.08L142.818 155.998V155.984Z"
        fill="#2E394D"
      />
      <path
        d="M137.073 177.63C137.073 177.63 137.728 181.119 137.482 181.984C137.236 182.849 136.527 183.124 135.422 183.151C134.317 183.179 132.202 182.327 130.619 181.599C129.036 180.871 127.426 180.94 125.775 180.707C124.124 180.459 120.631 178.33 120.318 176.902C120.017 175.487 120.768 174.732 122.132 174.141C123.51 173.551 128.477 174.141 128.477 174.141L137.059 177.63H137.073Z"
        fill="#13130A"
      />
      <path
        d="M120.318 176.902C120.632 178.317 124.125 180.459 125.775 180.707C127.426 180.954 129.036 180.885 130.619 181.599C132.202 182.327 134.33 183.193 135.422 183.151C136.513 183.124 137.237 182.835 137.482 181.984C137.51 181.888 137.523 181.764 137.537 181.599C137.537 181.805 137.537 181.984 137.537 182.121C137.55 182.506 137.537 182.849 137.496 183.041C137.25 183.907 136.541 184.181 135.436 184.209C134.33 184.236 132.216 183.385 130.633 182.657C130.319 182.52 130.005 182.396 129.691 182.314L129.828 181.709C128.504 181.311 127.167 181.311 125.803 181.119C124.152 180.885 120.659 178.743 120.345 177.314C120.277 177.012 120.263 176.751 120.291 176.518C120.291 176.641 120.318 176.765 120.345 176.888L120.318 176.902Z"
        fill="#13130A"
      />
      <path
        d="M126.008 148.472C128.941 150.861 135.954 154.474 135.954 154.474C135.954 154.474 135.954 163.58 136.418 168.744C136.882 173.908 137.305 178.111 137.305 178.111C137.305 178.111 133.458 180.432 129.815 178.853C126.158 177.273 127.331 174.059 127.331 174.059C127.822 167.522 126.308 154.158 126.008 148.485V148.472Z"
        fill="#354259"
      />
      <path
        d="M133.416 179.347C133.362 174.567 133.157 163.154 132.53 160.215C131.738 156.465 130.728 154.24 129.487 152.221C129.078 151.548 128.873 150.93 128.777 150.395C131.997 152.427 135.968 154.46 135.968 154.46C135.968 154.46 135.968 163.566 136.432 168.73C136.896 173.894 137.319 178.097 137.319 178.097C137.319 178.097 135.627 179.114 133.416 179.347Z"
        fill="#2E394D"
      />
      <path
        d="M188.457 118.405L187.53 117.815C187.257 117.609 186.82 117.636 186.261 117.966L162.97 131.686C161.879 132.318 160.76 133.857 160.487 135.093L158.645 143.457L157.553 142.825C156.68 142.317 155.902 142.303 155.357 142.674V142.55L129.965 157.425C129.337 157.7 128.928 158.4 128.928 159.444V181.488C128.928 183.177 129.978 185.196 131.356 186.309C131.506 186.446 131.698 186.583 131.902 186.707L151.577 198.134C153.214 199.082 155.902 199.082 157.54 198.134L177.215 186.707C177.992 186.254 178.402 185.663 178.443 185.059V183.878C178.47 183.232 178.061 182.587 177.215 182.092L170.393 178.123L158.126 170.816C157.117 170.226 156.216 168.907 155.875 167.644L178.497 154.513C179.439 154.033 181.513 152.453 181.772 151.244L182.263 148.978C182.304 148.855 182.345 148.731 182.372 148.607L188.744 119.724C188.894 119.064 188.771 118.625 188.457 118.433V118.405ZM159.559 174.964L175.277 184.098C175.427 184.18 175.55 184.276 175.646 184.386C175.55 184.496 175.427 184.592 175.277 184.674L156.066 195.841C155.247 196.321 153.91 196.321 153.078 195.841L134.877 185.265L134.89 185.347L133.935 184.798C132.653 184.056 131.52 182.092 131.52 180.595V163.248L135.327 161.037L149.326 169.168C149.967 169.539 150.663 169.745 151.332 169.745C151.85 169.745 152.328 169.635 152.751 169.429C152.819 169.402 152.887 169.36 152.955 169.319C153.46 170.748 154.565 172.107 155.766 172.808L159.545 174.978L159.559 174.964Z"
        fill="white"
      />
      <g opacity="0.3">
        <path
          d="M177.217 185.554L157.542 196.981C155.904 197.929 153.216 197.929 151.579 196.981L134.66 187.147L132.491 185.691C131.208 184.95 130.076 182.986 130.076 181.489V159.445C130.076 159.074 130.144 158.456 130.581 158.456C130.785 158.456 131.058 158.552 131.331 158.703L149.314 169.155C149.955 169.526 150.651 169.732 151.32 169.732C152.998 169.732 154.335 168.564 154.731 166.751L161.253 137.538L161.649 135.766C161.921 134.53 163.04 132.992 164.132 132.36L178.117 124.27L177.257 123.24L162.945 131.673C161.853 132.305 160.734 133.843 160.461 135.079L153.612 166.504C153.203 168.372 151.524 169.114 149.887 168.152L131.904 157.7C130.267 156.753 128.916 157.522 128.916 159.431V181.475C128.916 183.164 129.967 185.183 131.345 186.296C131.495 186.433 131.686 186.57 131.89 186.694L151.565 198.121C153.203 199.069 155.891 199.069 157.528 198.121L177.203 186.694C177.981 186.241 178.39 185.65 178.431 185.046V183.865C178.404 184.469 178.008 185.087 177.203 185.54L177.217 185.554Z"
          fill="#4A85C5"
        />
      </g>
      <g opacity="0.2">
        <path
          d="M188.692 118.667C188.228 118.626 187.641 118.791 187.136 119.079L164.159 132.374C163.068 133.006 161.949 134.545 161.676 135.781L161.28 137.552L154.758 166.766C154.513 167.865 153.926 168.73 153.107 169.238L155.864 167.631L178.486 154.501C179.427 154.02 181.501 152.441 181.76 151.232L182.251 148.966C182.292 148.842 182.333 148.719 182.361 148.595L188.732 119.711C188.828 119.272 188.801 118.915 188.678 118.681L188.692 118.667Z"
          fill="#4A85C5"
        />
      </g>
      <g opacity="0.4">
        <path
          d="M175.265 182.945L156.054 171.779C156.054 171.779 155.932 171.71 155.863 171.682C154.949 170.982 154.171 169.705 153.912 168.523C153.639 168.853 153.325 169.114 152.971 169.306C153.476 170.735 154.581 172.094 155.781 172.795L159.561 174.965L175.279 184.098C175.429 184.181 175.552 184.277 175.647 184.387C176.07 183.92 175.948 183.329 175.279 182.945H175.265Z"
          fill="#4B85C5"
        />
      </g>
      <g opacity="0.2">
        <path
          d="M177.217 182.079L170.395 178.11L158.129 170.803C157.119 170.213 156.219 168.894 155.877 167.631L153.981 168.743C154.281 169.856 155.018 171.023 155.877 171.696C155.946 171.724 156 171.751 156.068 171.792L175.28 182.958C175.948 183.343 176.071 183.934 175.648 184.401C175.552 184.51 175.43 184.607 175.28 184.689L156.068 195.855C155.25 196.336 153.913 196.336 153.08 195.855L134.879 185.28L134.893 185.362L133.938 184.813C132.655 184.071 131.522 182.107 131.522 180.61V158.84L131.345 158.731C131.059 158.566 130.799 158.483 130.595 158.483C130.144 158.483 130.09 159.101 130.09 159.472V181.516C130.09 183.013 131.222 184.964 132.505 185.719L134.674 187.175L151.593 197.009C153.23 197.957 155.918 197.957 157.556 197.009L177.231 185.582C178.022 185.115 178.431 184.51 178.459 183.906C178.486 183.261 178.077 182.615 177.231 182.121L177.217 182.079Z"
          fill="#4A85C5"
        />
      </g>
      <g opacity="0.4">
        <path
          d="M135.328 161.038L131.344 158.717L131.521 158.827V163.249L135.328 161.038Z"
          fill="#4B85C5"
        />
      </g>
      <mask
        id="mask0_1563_101126"
        maskUnits="userSpaceOnUse"
        x="56"
        y="135"
        width="5"
        height="68"
      >
        <path
          d="M60.6244 135.507H56.4766V202.82H60.6244V135.507Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1563_101126)">
        <path
          d="M60.625 136.029L60.6113 135.507H60.625V136.029Z"
          fill="#C9CDE3"
        />
        <path
          d="M60.6255 144.682L60.4746 135.507H60.6118L60.6255 136.029V144.682Z"
          fill="#CACEE4"
        />
        <path
          d="M60.6244 153.334L60.3379 135.507H60.4743L60.6244 144.682V153.334Z"
          fill="#CBCFE4"
        />
        <path
          d="M60.6241 161.987L60.2012 135.507H60.3376L60.6241 153.334V161.987Z"
          fill="#CBD0E5"
        />
        <path
          d="M60.6239 170.64L60.0645 135.507H60.2009L60.6239 161.987V170.64Z"
          fill="#CCD1E6"
        />
        <path
          d="M60.6236 179.293L59.9141 135.507H60.0641L60.6236 170.64V179.293Z"
          fill="#CDD1E7"
        />
        <path
          d="M60.6233 187.945L59.7773 135.507H59.9138L60.6233 179.293V187.945Z"
          fill="#CED2E8"
        />
        <path
          d="M60.625 196.598L59.6426 135.507H59.779L60.625 187.945V196.598Z"
          fill="#CED3E8"
        />
        <path
          d="M60.5818 202.806L59.5039 135.507H59.6403L60.6227 196.598V202.806H60.5818Z"
          fill="#CFD4E9"
        />
        <path
          d="M60.447 202.806L59.3555 135.507H59.5056L60.5834 202.806H60.447Z"
          fill="#D0D5EA"
        />
        <path
          d="M60.3103 202.806L59.2188 135.507H59.3552L60.4467 202.806H60.3103Z"
          fill="#D1D5EA"
        />
        <path
          d="M60.1599 202.806L59.082 135.507H59.2185L60.31 202.806H60.1599Z"
          fill="#D1D6EB"
        />
        <path
          d="M60.0232 202.806L58.9453 135.507H59.0818L60.1596 202.806H60.0232Z"
          fill="#D2D7EC"
        />
        <path
          d="M59.8884 202.806L58.8105 135.507H58.947L60.0249 202.806H59.8884Z"
          fill="#D2D7EC"
        />
        <path
          d="M59.7517 202.806L58.6602 135.507H58.8102L59.8881 202.806H59.7517Z"
          fill="#D3D8ED"
        />
        <path
          d="M59.615 202.806L58.5234 135.507H58.6599L59.7514 202.806H59.615Z"
          fill="#D4D9ED"
        />
        <path
          d="M59.4646 202.806L58.3867 135.507H58.5232L59.6147 202.806H59.4646Z"
          fill="#D4D9EE"
        />
        <path
          d="M59.3279 202.806L58.25 135.507H58.3864L59.4643 202.806H59.3279Z"
          fill="#D5DAEE"
        />
        <path
          d="M59.1912 202.806L58.0996 135.507H58.2497L59.3276 202.806H59.1912Z"
          fill="#D5DAEF"
        />
        <path
          d="M59.0544 202.806L57.9629 135.507H58.0993L59.1909 202.806H59.0544Z"
          fill="#D6DBEF"
        />
        <path
          d="M58.906 202.806L57.8281 135.507H57.9646L59.0561 202.806H58.906Z"
          fill="#D6DBF0"
        />
        <path
          d="M58.7693 202.806L57.6914 135.507H57.8279L58.9057 202.806H58.7693Z"
          fill="#D6DBF0"
        />
        <path
          d="M58.6326 202.806L57.5547 135.507H57.6911L58.769 202.806H58.6326Z"
          fill="#D7DCF0"
        />
        <path
          d="M58.4958 202.806L57.4043 135.507H57.5544L58.6323 202.806H58.4958Z"
          fill="#D7DCF0"
        />
        <path
          d="M58.3591 202.806L57.2676 135.507H57.404L58.4956 202.806H58.3591Z"
          fill="#D7DCF1"
        />
        <path
          d="M58.2088 202.806L57.1309 135.507H57.2673L58.3588 202.806H58.2088Z"
          fill="#D7DCF1"
        />
        <path
          d="M57.1315 135.507L58.2094 202.806H56.4766V135.507H57.1315Z"
          fill="#D7DCF1"
        />
      </g>
      <mask
        id="mask1_1563_101126"
        maskUnits="userSpaceOnUse"
        x="88"
        y="152"
        width="5"
        height="68"
      >
        <path d="M92.6478 152.688H88.5V220.001H92.6478V152.688Z" fill="white" />
      </mask>
      <g mask="url(#mask1_1563_101126)">
        <path
          d="M92.6485 153.209L92.6348 152.688H92.6485V153.209Z"
          fill="#C9CDE3"
        />
        <path
          d="M92.6489 161.862L92.498 152.688H92.6352L92.6489 153.209V161.862Z"
          fill="#CACEE4"
        />
        <path
          d="M92.6479 170.515L92.3613 152.688H92.4978L92.6479 161.862V170.515Z"
          fill="#CBCFE4"
        />
        <path
          d="M92.6476 179.168L92.2246 152.688H92.361L92.6476 170.515V179.168Z"
          fill="#CBD0E5"
        />
        <path
          d="M92.6473 187.821L92.0742 152.688H92.2243L92.6473 179.168V187.821Z"
          fill="#CCD1E6"
        />
        <path
          d="M92.647 196.473L91.9375 152.688H92.0739L92.647 187.821V196.473Z"
          fill="#CDD1E7"
        />
        <path
          d="M92.6467 205.126L91.8008 152.688H91.9372L92.6467 196.473V205.126Z"
          fill="#CED2E8"
        />
        <path
          d="M92.6484 213.779L91.666 152.688H91.8025L92.6484 205.126V213.779Z"
          fill="#CED3E8"
        />
        <path
          d="M92.6052 220.001L91.5137 152.688H91.6638L92.6461 213.779V220.001H92.6052Z"
          fill="#CFD4E9"
        />
        <path
          d="M92.4704 220.001L91.3789 152.688H91.5153L92.6069 220.001H92.4704Z"
          fill="#D0D5EA"
        />
        <path
          d="M92.3337 220.001L91.2422 152.688H91.3786L92.4702 220.001H92.3337Z"
          fill="#D1D5EA"
        />
        <path
          d="M92.1834 220.001L91.1055 152.688H91.2419L92.3335 220.001H92.1834Z"
          fill="#D1D6EB"
        />
        <path
          d="M92.0466 220.001L90.9688 152.688H91.1052L92.1831 220.001H92.0466Z"
          fill="#D2D7EC"
        />
        <path
          d="M91.9118 220.001L90.8203 152.688H90.9704L92.0483 220.001H91.9118Z"
          fill="#D2D7EC"
        />
        <path
          d="M91.7751 220.001L90.6836 152.688H90.82L91.9116 220.001H91.7751Z"
          fill="#D3D8ED"
        />
        <path
          d="M91.6248 220.001L90.5469 152.688H90.6833L91.7749 220.001H91.6248Z"
          fill="#D4D9ED"
        />
        <path
          d="M91.4881 220.001L90.4102 152.688H90.5466L91.6245 220.001H91.4881Z"
          fill="#D4D9EE"
        />
        <path
          d="M91.3513 220.001L90.2598 152.688H90.4099L91.4877 220.001H91.3513Z"
          fill="#D5DAEE"
        />
        <path
          d="M91.2165 220.001L90.125 152.688H90.2614L91.353 220.001H91.2165Z"
          fill="#D5DAEF"
        />
        <path
          d="M91.0779 220.001L89.9863 152.688H90.1228L91.2143 249.077L91.0779 220.001Z"
          fill="#D6DBEF"
        />
        <path
          d="M90.9294 220.001L89.8516 152.688H89.988L91.0795 220.001H90.9294Z"
          fill="#D6DBF0"
        />
        <path
          d="M90.7927 220.001L89.7148 152.688H89.8513L90.9292 220.001H90.7927Z"
          fill="#D6DBF0"
        />
        <path
          d="M90.656 220.001L89.5645 152.688H89.7145L90.7924 220.001H90.656Z"
          fill="#D7DCF0"
        />
        <path
          d="M90.5173 220.001L89.4258 152.688H89.5622L90.6538 220.001H90.5173Z"
          fill="#D7DCF0"
        />
        <path
          d="M90.3689 220.001L89.291 152.688H89.4275L90.519 220.001H90.3689Z"
          fill="#D7DCF1"
        />
        <path
          d="M90.2322 220.001L89.1543 152.688H89.2907L90.3686 220.001H90.2322Z"
          fill="#D7DCF1"
        />
        <path
          d="M89.1549 152.688L90.2328 220.001H88.5V152.688H89.1549Z"
          fill="#D7DCF1"
        />
      </g>
      <mask
        id="mask2_1563_101126"
        maskUnits="userSpaceOnUse"
        x="53"
        y="83"
        width="124"
        height="76"
      >
        <path
          d="M175.726 105.674L139.433 84.6056C137.864 83.6992 135.285 83.6992 133.702 84.6056L54.9613 130.438C54.1563 130.905 53.7606 131.523 53.7879 132.141V134.957C53.706 135.616 54.1017 136.303 54.9613 136.797L91.2549 157.852C92.824 158.772 95.4027 158.759 96.9855 157.852L175.726 112.02C176.545 111.539 176.941 110.907 176.9 110.289V107.378C176.927 106.759 176.531 106.128 175.726 105.647V105.674Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_1563_101126)">
        <path
          d="M77.2979 83.7002L53.7207 126.209V83.7002H77.2979Z"
          fill="#ACB0C8"
        />
        <path
          d="M88.1041 83.7002L57.4319 139.009L53.7207 136.935V126.209L77.2979 83.7002H88.1041Z"
          fill="#ACB0C8"
        />
        <path
          d="M88.9361 83.7002L58.0593 139.366L57.4316 139.009L88.1038 83.7002H88.9361Z"
          fill="#ACB0C8"
        />
        <path
          d="M89.7541 83.7002L58.6862 139.723L58.0586 139.366L88.9355 83.7002H89.7541Z"
          fill="#ADB1C9"
        />
        <path
          d="M90.5877 83.7002L59.3288 140.081L58.6875 139.723L89.7554 83.7002H90.5877Z"
          fill="#AEB3CA"
        />
        <path
          d="M91.4193 83.7002L59.9558 140.438L59.3281 140.081L90.587 83.7002H91.4193Z"
          fill="#B0B4CB"
        />
        <path
          d="M92.2373 83.7002L60.5827 140.781L59.9551 140.438L91.4187 83.7002H92.2373Z"
          fill="#B1B5CD"
        />
        <path
          d="M93.0709 83.7002L61.2116 141.138L60.584 140.781L92.2386 83.7002H93.0709Z"
          fill="#B2B6CE"
        />
        <path
          d="M93.9025 83.7002L61.8522 141.495L61.2109 141.138L93.0702 83.7002H93.9025Z"
          fill="#B4B8CF"
        />
        <path
          d="M94.7205 83.7002L62.4792 141.852L61.8516 141.495L93.9018 83.7002H94.7205Z"
          fill="#B5B9D0"
        />
        <path
          d="M95.5541 83.7002L63.1081 142.209L62.4805 141.852L94.7218 83.7002H95.5541Z"
          fill="#B6BAD1"
        />
        <path
          d="M96.3857 83.7002L63.7351 142.553L63.1074 142.209L95.5534 83.7002H96.3857Z"
          fill="#B7BBD2"
        />
        <path
          d="M97.2037 83.7002L64.362 142.91L63.7344 142.553L96.385 83.7002H97.2037Z"
          fill="#B9BDD4"
        />
        <path
          d="M98.0372 83.7002L65.0046 143.267L64.3633 142.91L97.2049 83.7002H98.0372Z"
          fill="#BABED5"
        />
        <path
          d="M98.8689 83.7002L65.6315 143.624L65.0039 143.267L98.0366 83.7002H98.8689Z"
          fill="#BBBFD6"
        />
        <path
          d="M99.6888 83.7002L66.2604 143.981L65.6328 143.624L98.8701 83.7002H99.6888Z"
          fill="#BCC0D7"
        />
        <path
          d="M100.52 83.7002L66.8874 144.338L66.2598 143.981L99.6881 83.7002H100.52Z"
          fill="#BEC1D8"
        />
        <path
          d="M101.352 83.7002L67.528 144.682L66.8867 144.338L100.52 83.7002H101.352Z"
          fill="#BFC3D9"
        />
        <path
          d="M102.172 83.7002L68.1569 145.039L67.5293 144.682L101.353 83.7002H102.172Z"
          fill="#C0C4DA"
        />
        <path
          d="M103.004 83.7002L68.7839 145.396L68.1562 145.039L102.171 83.7002H103.004Z"
          fill="#C1C5DB"
        />
        <path
          d="M103.835 83.7002L69.4108 145.753L68.7832 145.396L103.003 83.7002H103.835Z"
          fill="#C2C6DC"
        />
        <path
          d="M104.655 83.7002L70.0534 146.11L69.4121 145.753L103.836 83.7002H104.655Z"
          fill="#C3C7DD"
        />
        <path
          d="M105.487 83.7002L70.6804 146.453L70.0527 146.11L104.654 83.7002H105.487Z"
          fill="#C4C8DE"
        />
        <path
          d="M106.305 83.7002L71.3073 146.811L70.6797 146.453L105.486 83.7002H106.305Z"
          fill="#C5C9DF"
        />
        <path
          d="M107.138 83.7002L71.9362 147.168L71.3086 146.811L106.306 83.7002H107.138Z"
          fill="#C6CAE0"
        />
        <path
          d="M107.97 83.7002L72.5768 147.525L71.9355 147.168L107.138 83.7002H107.97Z"
          fill="#C7CBE1"
        />
        <path
          d="M108.788 83.7002L73.2038 147.882L72.5762 147.525L107.969 83.7002H108.788Z"
          fill="#C8CCE2"
        />
        <path
          d="M109.622 83.7002L73.8327 148.225L73.2051 147.882L108.789 83.7002H109.622Z"
          fill="#C9CDE3"
        />
        <path
          d="M110.453 83.7002L74.4597 148.582L73.832 148.225L109.621 83.7002H110.453Z"
          fill="#CACEE4"
        />
        <path
          d="M111.273 83.7002L75.0886 148.939L74.4609 148.582L110.454 83.7002H111.273Z"
          fill="#CBCFE4"
        />
        <path
          d="M112.105 83.7002L75.7292 149.296L75.0879 148.939L111.272 83.7002H112.105Z"
          fill="#CBD0E5"
        />
        <path
          d="M112.936 83.7002L76.3561 149.654L75.7285 149.296L112.104 83.7002H112.936Z"
          fill="#CCD1E6"
        />
        <path
          d="M113.754 83.7002L76.9831 150.011L76.3555 149.654L112.936 83.7002H113.754Z"
          fill="#CDD1E7"
        />
        <path
          d="M114.588 83.7002L77.612 150.354L76.9844 150.011L113.756 83.7002H114.588Z"
          fill="#CED2E8"
        />
        <path
          d="M115.419 83.7002L78.2526 150.711L77.6113 150.354L114.587 83.7002H115.419Z"
          fill="#CED3E8"
        />
        <path
          d="M116.239 83.7002L78.8815 151.068L78.2539 150.711L115.421 83.7002H116.239Z"
          fill="#CFD4E9"
        />
        <path
          d="M117.071 83.7002L79.5085 151.425L78.8809 151.068L116.239 83.7002H117.071Z"
          fill="#D0D5EA"
        />
        <path
          d="M117.903 83.7002L80.1354 151.782L79.5078 151.425L117.07 83.7002H117.903Z"
          fill="#D1D5EA"
        />
        <path
          d="M118.721 83.7002L80.776 152.126L80.1348 151.782L117.902 83.7002H118.721Z"
          fill="#D1D6EB"
        />
        <path
          d="M119.554 83.7002L81.405 152.483L80.7773 152.126L118.722 83.7002H119.554Z"
          fill="#D2D7EC"
        />
        <path
          d="M120.386 83.7002L82.0319 152.84L81.4043 152.483L119.554 83.7002H120.386Z"
          fill="#D2D7EC"
        />
        <path
          d="M121.204 83.7002L82.6589 153.197L82.0312 152.84L120.385 83.7002H121.204Z"
          fill="#D3D8ED"
        />
        <path
          d="M122.035 83.7002L83.2995 153.554L82.6582 153.197L121.203 83.7002H122.035Z"
          fill="#D4D9ED"
        />
        <path
          d="M122.855 83.7002L83.9284 153.911L83.3008 153.554L122.037 83.7002H122.855Z"
          fill="#D4D9EE"
        />
        <path
          d="M123.689 83.7002L84.5573 154.255L83.9297 153.911L122.857 83.7002H123.689Z"
          fill="#D5DAEE"
        />
        <path
          d="M124.521 83.7002L85.1843 154.612L84.5566 154.255L123.688 83.7002H124.521Z"
          fill="#D5DAEF"
        />
        <path
          d="M125.339 83.7002L85.8249 154.969L85.1836 154.612L124.52 83.7002H125.339Z"
          fill="#D6DBEF"
        />
        <path
          d="M126.172 83.7002L86.4538 155.326L85.8262 154.969L125.34 83.7002H126.172Z"
          fill="#D6DBF0"
        />
        <path
          d="M127.004 83.7002L87.0808 155.683L86.4531 155.326L126.171 83.7002H127.004Z"
          fill="#D6DBF0"
        />
        <path
          d="M127.822 83.7002L87.7077 156.026L87.0801 155.683L127.003 83.7002H127.822Z"
          fill="#D7DCF0"
        />
        <path
          d="M128.653 83.7002L88.3347 156.384L87.707 156.026L127.821 83.7002H128.653Z"
          fill="#D7DCF0"
        />
        <path
          d="M129.487 83.7002L88.9772 156.741L88.3359 156.383L128.655 83.7002H129.487Z"
          fill="#D7DCF1"
        />
        <path
          d="M130.305 83.7002L89.6042 157.098L88.9766 156.741L129.486 83.7002H130.305Z"
          fill="#D7DCF1"
        />
        <path
          d="M138.07 83.7002L176.942 105.552V158.801H92.6345L89.6055 157.098L130.306 83.7002H138.07Z"
          fill="#D7DCF1"
        />
      </g>
      <path
        d="M139.433 84.6193C137.864 83.7128 135.286 83.7128 133.703 84.6193L54.962 130.452C53.3929 131.372 53.3929 132.869 54.962 133.775L91.2556 154.844C92.8247 155.751 95.4034 155.751 96.9862 154.844L175.727 109.012C177.296 108.092 177.296 106.595 175.727 105.688L139.433 84.6193Z"
        fill="white"
      />
      <mask
        id="mask3_1563_101126"
        maskUnits="userSpaceOnUse"
        x="104"
        y="114"
        width="42"
        height="26"
      >
        <path
          d="M104.066 131.288L117.547 139.117L145.872 122.663L132.392 114.82L104.066 131.288Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_1563_101126)">
        <path
          d="M104.066 138.938L104.162 139.116H104.066V138.938Z"
          fill="#D6DBEF"
        />
        <path
          d="M104.066 138.637L104.326 139.117H104.162L104.066 138.939V138.637Z"
          fill="#D6DBF0"
        />
        <path
          d="M104.066 138.334L104.476 139.117H104.326L104.066 138.636V138.334Z"
          fill="#D6DBF0"
        />
        <path
          d="M104.066 138.032L104.639 139.117H104.476L104.066 138.334V138.032Z"
          fill="#D7DCF0"
        />
        <path
          d="M104.066 137.743L104.79 139.117H104.639L104.066 138.032V137.743Z"
          fill="#D7DCF0"
        />
        <path
          d="M104.066 137.441L104.953 139.117H104.79L104.066 137.744V137.441Z"
          fill="#D7DCF1"
        />
        <path
          d="M104.066 137.141L105.103 139.118H104.953L104.066 137.443V137.141Z"
          fill="#D7DCF1"
        />
        <path
          d="M104.066 129.791L132.16 114.82H145.872V124.16L117.779 139.117H105.103L104.066 137.139V129.791Z"
          fill="#D7DCF1"
        />
      </g>
      <path
        d="M128.298 62.6854C128.298 62.0261 127.834 61.7515 127.261 62.0811L84.5819 86.8857C84.0088 87.2153 83.5449 88.0257 83.5449 88.6987V122.293C83.5449 122.953 84.0088 123.227 84.5819 122.898L127.261 98.0931C127.834 97.7635 128.298 96.9531 128.298 96.2801V62.6854Z"
        fill="white"
      />
      <g opacity="0.2">
        <path
          d="M128.298 62.6844C128.298 62.0252 127.834 61.7505 127.261 62.0801L84.5819 86.8847C84.0088 87.2143 83.5449 88.0247 83.5449 88.6977V122.292C83.5449 122.952 84.0088 123.226 84.5819 122.897L127.261 98.0921C127.834 97.7625 128.298 96.9522 128.298 96.2792V62.6844Z"
          fill="#4A85C5"
        />
      </g>
      <mask
        id="mask4_1563_101126"
        maskUnits="userSpaceOnUse"
        x="83"
        y="63"
        width="46"
        height="57"
      >
        <path
          d="M128.298 93.3412V63.084L83.5449 89.0972V119.341L128.298 93.3412Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask4_1563_101126)">
        <path
          opacity="0.2"
          d="M88.9071 63.084L83.5449 74.1952V63.084H88.9071Z"
          fill="url(#paint0_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M89.1936 63.084L83.5449 74.7858V74.1952L88.9071 63.084H89.1936Z"
          fill="url(#paint1_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M89.4802 63.084L83.5449 75.3627V74.7858L89.1936 63.084H89.4802Z"
          fill="url(#paint2_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M89.7667 63.084L83.5449 75.9533V75.3627L89.4802 63.084H89.7667Z"
          fill="url(#paint3_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M90.0396 63.084L83.5449 76.5439V75.9533L89.7667 63.084H90.0396Z"
          fill="url(#paint4_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M90.3261 63.084L83.5449 77.1344V76.5439L90.0396 63.084H90.3261Z"
          fill="url(#paint5_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M90.6126 63.084L83.5449 77.7113V77.1344L90.3261 63.084H90.6126Z"
          fill="url(#paint6_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M90.8992 63.084L83.5449 78.3019V77.7113L90.6126 63.084H90.8992Z"
          fill="url(#paint7_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M91.172 63.084L83.5449 78.8925V78.3019L90.8992 63.084H91.172Z"
          fill="url(#paint8_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M91.4586 63.084L83.5449 79.4831V78.8925L91.172 63.084H91.4586Z"
          fill="url(#paint9_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M91.7451 63.084L83.5449 80.0599V79.483L91.4586 63.084H91.7451Z"
          fill="url(#paint10_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M92.0316 63.084L83.5449 80.6505V80.0599L91.7451 63.084H92.0316Z"
          fill="url(#paint11_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M92.3182 63.084L83.5449 81.2411V80.6505L92.0316 63.084H92.3182Z"
          fill="url(#paint12_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M92.591 63.084L83.5449 81.8317V81.2411L92.3182 63.084H92.591Z"
          fill="url(#paint13_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M92.8776 63.084L83.5449 82.4085V81.8317L92.591 63.084H92.8776Z"
          fill="url(#paint14_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M93.1641 63.084L83.5449 82.9991V82.4085L92.8776 63.084H93.1641Z"
          fill="url(#paint15_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M93.4506 63.084L83.5449 83.5897V82.9991L93.1641 63.084H93.4506Z"
          fill="url(#paint16_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M93.7235 63.084L83.5449 84.1803V83.5897L93.4506 63.084H93.7235Z"
          fill="url(#paint17_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M94.01 63.084L83.5449 84.7571V84.1803L93.7235 63.084H94.01Z"
          fill="url(#paint18_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M94.2966 63.084L83.5449 85.3477V84.7571L94.01 63.084H94.2966Z"
          fill="url(#paint19_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M94.5831 63.084L83.5449 85.9383V85.3477L94.2966 63.084H94.5831Z"
          fill="url(#paint20_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M94.8696 63.084L83.5449 86.5152V85.9383L94.5831 63.084H94.8696Z"
          fill="url(#paint21_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M95.1425 63.084L83.5449 87.1057V86.5152L94.8696 63.084H95.1425Z"
          fill="url(#paint22_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M95.429 63.084L83.5449 87.6963V87.1057L95.1425 63.084H95.429Z"
          fill="url(#paint23_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M95.7156 63.084L83.5449 88.2869V87.6963L95.429 63.084H95.7156Z"
          fill="url(#paint24_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M96.0021 63.084L83.5449 88.8638V88.2869L95.7156 63.084H96.0021Z"
          fill="url(#paint25_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M96.275 63.084L83.5449 89.4543V88.8638L96.0021 63.084H96.275Z"
          fill="url(#paint26_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M96.5615 63.084L83.5449 90.0449V89.4543L96.275 63.084H96.5615Z"
          fill="url(#paint27_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M96.848 63.084L83.5449 90.6355V90.0449L96.5615 63.084H96.848Z"
          fill="url(#paint28_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M97.1346 63.084L83.5449 91.2124V90.6355L96.848 63.084H97.1346Z"
          fill="url(#paint29_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M97.4211 63.084L83.5449 91.8029V91.2124L97.1346 63.084H97.4211Z"
          fill="url(#paint30_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M97.694 63.084L83.5449 92.3935V91.8029L97.4211 63.084H97.694Z"
          fill="url(#paint31_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M97.9805 63.084L83.5449 92.9841V92.3935L97.694 63.084H97.9805Z"
          fill="url(#paint32_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M98.267 63.084L83.5449 93.561V92.9841L97.9805 63.084H98.267Z"
          fill="url(#paint33_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M98.5536 63.084L83.5449 94.1516V93.561L98.267 63.084H98.5536Z"
          fill="url(#paint34_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M98.8264 63.084L83.5449 94.7422V94.1516L98.5536 63.084H98.8264Z"
          fill="url(#paint35_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M99.113 63.084L83.5449 95.3327V94.7422L98.8264 63.084H99.113Z"
          fill="url(#paint36_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M99.3995 63.084L83.5449 95.9096V95.3327L99.113 63.084H99.3995Z"
          fill="url(#paint37_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M99.686 63.084L83.5449 96.5002V95.9096L99.3995 63.084H99.686Z"
          fill="url(#paint38_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M99.9726 63.084L83.5449 97.0908V96.5002L99.686 63.084H99.9726Z"
          fill="url(#paint39_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M100.245 63.084L83.5449 97.6813V97.0908L99.9726 63.084H100.245Z"
          fill="url(#paint40_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M100.532 63.084L83.5449 98.2582V97.6813L100.245 63.084H100.532Z"
          fill="url(#paint41_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M100.819 63.084L83.5449 98.8488V98.2582L100.532 63.084H100.819Z"
          fill="url(#paint42_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M101.105 63.084L83.5449 99.4394V98.8488L100.819 63.084H101.105Z"
          fill="url(#paint43_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M101.378 63.084L83.5449 100.016V99.4394L101.105 63.084H101.378Z"
          fill="url(#paint44_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M101.664 63.084L83.5449 100.607V100.016L101.378 63.084H101.664Z"
          fill="url(#paint45_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M101.951 63.084L83.5449 101.197V100.607L101.664 63.084H101.951Z"
          fill="url(#paint46_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M102.238 63.084L83.5449 101.788V101.197L101.951 63.084H102.238Z"
          fill="url(#paint47_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M102.524 63.084L83.5449 102.365V101.788L102.238 63.084H102.524Z"
          fill="url(#paint48_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M102.797 63.084L83.5449 102.955V102.365L102.524 63.084H102.797Z"
          fill="url(#paint49_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M103.083 63.084L83.5449 103.546V102.955L102.797 63.084H103.083Z"
          fill="url(#paint50_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M103.37 63.084L83.5449 104.137V103.546L103.083 63.084H103.37Z"
          fill="url(#paint51_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M103.656 63.084L83.5449 104.713V104.137L103.37 63.084H103.656Z"
          fill="url(#paint52_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M103.929 63.084L83.5449 105.304V104.713L103.657 63.084H103.929Z"
          fill="url(#paint53_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M104.216 63.084L83.5449 105.895V105.304L103.929 63.084H104.216Z"
          fill="url(#paint54_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M104.502 63.084L83.5449 106.485V105.895L104.216 63.084H104.502Z"
          fill="url(#paint55_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M104.789 63.084L83.5449 107.062V106.485L104.502 63.084H104.789Z"
          fill="url(#paint56_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M105.076 63.084L83.5449 107.653V107.062L104.789 63.084H105.076Z"
          fill="url(#paint57_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M105.348 63.084L83.5449 108.243V107.653L105.076 63.084H105.348Z"
          fill="url(#paint58_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M105.635 63.084L83.5449 108.834V108.243L105.348 63.084H105.635Z"
          fill="url(#paint59_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M105.921 63.084L83.5449 109.411V108.834L105.635 63.084H105.921Z"
          fill="url(#paint60_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M106.208 63.084L83.5449 110.001V109.411L105.921 63.084H106.208Z"
          fill="url(#paint61_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M106.481 63.084L83.5449 110.592V110.001L106.208 63.084H106.481Z"
          fill="url(#paint62_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M106.767 63.084L83.5449 111.182V110.592L106.481 63.084H106.767Z"
          fill="url(#paint63_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M107.054 63.084L83.5449 111.759V111.182L106.767 63.084H107.054Z"
          fill="url(#paint64_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M107.34 63.084L83.5449 112.35V111.759L107.054 63.084H107.34Z"
          fill="url(#paint65_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M107.627 63.084L83.5449 112.94V112.35L107.34 63.084H107.627Z"
          fill="url(#paint66_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M107.9 63.084L83.5449 113.517V112.94L107.627 63.084H107.9Z"
          fill="url(#paint67_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M108.186 63.084L83.5449 114.108V113.517L107.9 63.084H108.186Z"
          fill="url(#paint68_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M108.473 63.084L83.5449 114.698V114.108L108.186 63.084H108.473Z"
          fill="url(#paint69_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M108.759 63.084L83.5449 115.289V114.698L108.473 63.084H108.759Z"
          fill="url(#paint70_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M109.032 63.084L83.5449 115.866V115.289L108.759 63.084H109.032Z"
          fill="url(#paint71_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M109.319 63.084L83.5449 116.456V115.866L109.032 63.084H109.319Z"
          fill="url(#paint72_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M109.605 63.084L83.5449 117.047V116.456L109.319 63.084H109.605Z"
          fill="url(#paint73_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M109.892 63.084L83.5449 117.638V117.047L109.605 63.084H109.892Z"
          fill="url(#paint74_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M110.165 63.084L83.5449 118.215V117.638L109.892 63.084H110.165Z"
          fill="url(#paint75_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M110.451 63.084L83.5449 118.805V118.215L110.165 63.084H110.451Z"
          fill="url(#paint76_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M110.738 63.084L83.5722 119.341H83.5449V118.805L110.451 63.084H110.738Z"
          fill="url(#paint77_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M111.024 63.084L83.8588 119.341H83.5723L110.738 63.084H111.024Z"
          fill="url(#paint78_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M111.312 63.084L84.1459 119.341H83.8594L111.025 63.084H111.312Z"
          fill="url(#paint79_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M111.585 63.084L84.4194 119.341H84.1465L111.312 63.084H111.585Z"
          fill="url(#paint80_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M111.87 63.084L84.7045 119.341H84.418L111.584 63.084H111.87Z"
          fill="url(#paint81_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M112.157 63.084L84.9916 119.341H84.7051L111.871 63.084H112.157Z"
          fill="url(#paint82_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M112.444 63.084L85.2787 119.341H84.9922L112.158 63.084H112.444Z"
          fill="url(#paint83_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M112.716 63.084L85.5502 119.341H85.2773L112.443 63.084H112.716Z"
          fill="url(#paint84_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M113.003 63.084L85.8373 119.341H85.5508L112.716 63.084H113.003Z"
          fill="url(#paint85_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M113.29 63.084L86.1244 119.341H85.8379L113.004 63.084H113.29Z"
          fill="url(#paint86_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M113.575 63.084L86.4096 119.341H86.123L113.289 63.084H113.575Z"
          fill="url(#paint87_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M113.862 63.084L86.6967 119.341H86.4102L113.576 63.084H113.862Z"
          fill="url(#paint88_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M114.136 63.084L86.9702 119.341H86.6973L113.863 63.084H114.136Z"
          fill="url(#paint89_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M114.423 63.084L87.2572 119.341H86.9707L114.136 63.084H114.423Z"
          fill="url(#paint90_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M114.708 63.084L87.5424 119.341H87.2559L114.422 63.084H114.708Z"
          fill="url(#paint91_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M114.995 63.084L87.8295 119.341H87.543L114.709 63.084H114.995Z"
          fill="url(#paint92_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M115.269 63.084L88.103 119.341H87.8301L114.996 63.084H115.269Z"
          fill="url(#paint93_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M115.556 63.084L88.3901 119.341H88.1035L115.269 63.084H115.556Z"
          fill="url(#paint94_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M115.841 63.084L88.6752 119.341H88.3887L115.554 63.084H115.841Z"
          fill="url(#paint95_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M116.128 63.084L88.9623 119.341H88.6758L115.841 63.084H116.128Z"
          fill="url(#paint96_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M116.413 63.084L89.2475 119.341H88.9609L116.127 63.084H116.413Z"
          fill="url(#paint97_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M116.687 63.084L89.5209 119.341H89.248L116.414 63.084H116.687Z"
          fill="url(#paint98_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M116.974 63.084L89.808 119.341H89.5215L116.687 63.084H116.974Z"
          fill="url(#paint99_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M117.261 63.084L90.0951 119.341H89.8086L116.974 63.084H117.261Z"
          fill="url(#paint100_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M117.546 63.084L90.3803 119.341H90.0938L117.259 63.084H117.546Z"
          fill="url(#paint101_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M117.821 63.084L90.6557 119.341H90.3828L117.548 63.084H117.821Z"
          fill="url(#paint102_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M118.106 63.084L90.9408 119.341H90.6543L117.82 63.084H118.106Z"
          fill="url(#paint103_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M118.394 63.084L91.2279 119.341H90.9414L118.107 63.084H118.394Z"
          fill="url(#paint104_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M118.679 63.084L91.5131 119.341H91.2266L118.392 63.084H118.679Z"
          fill="url(#paint105_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M118.966 63.084L91.8002 119.341H91.5137L118.679 63.084H118.966Z"
          fill="url(#paint106_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M119.237 63.084L92.0717 119.341H91.7988L118.964 63.084H119.237Z"
          fill="url(#paint107_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M119.524 63.084L92.3588 119.341H92.0723L119.238 63.084H119.524Z"
          fill="url(#paint108_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M119.812 63.084L92.6459 119.341H92.3594L119.525 63.084H119.812Z"
          fill="url(#paint109_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M120.099 63.084L92.933 119.341H92.6465L119.812 63.084H120.099Z"
          fill="url(#paint110_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M120.37 63.084L93.2045 119.341H92.9316L120.097 63.084H120.37Z"
          fill="url(#paint111_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M120.657 63.084L93.4916 119.341H93.2051L120.371 63.084H120.657Z"
          fill="url(#paint112_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M120.944 63.084L93.7787 119.341H93.4922L120.658 63.084H120.944Z"
          fill="url(#paint113_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M121.231 63.084L94.0658 119.341H93.7793L120.945 63.084H121.231Z"
          fill="url(#paint114_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M121.517 63.084L94.3373 119.341H94.0645L121.23 63.084H121.517Z"
          fill="url(#paint115_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M121.79 63.084L94.6244 119.341H94.3379L121.517 63.084H121.79Z"
          fill="url(#paint116_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M122.077 63.084L94.9115 119.341H94.625L121.791 63.084H122.077Z"
          fill="url(#paint117_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M122.364 63.084L95.1986 119.341H94.9121L122.078 63.084H122.364Z"
          fill="url(#paint118_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M122.649 63.084L95.4838 119.341H95.1973L122.363 63.084H122.649Z"
          fill="url(#paint119_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M122.923 63.084L95.7573 119.341H95.4844L122.65 63.084H122.923Z"
          fill="url(#paint120_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M123.208 63.084L96.0424 119.341H95.7559L122.922 63.084H123.208Z"
          fill="url(#paint121_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M123.495 63.084L96.3295 119.341H96.043L123.209 63.084H123.495Z"
          fill="url(#paint122_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M123.782 63.084L96.6166 119.341H96.3301L123.496 63.084H123.782Z"
          fill="url(#paint123_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M124.069 63.084L96.8901 119.341H96.6172L123.783 63.084H124.069Z"
          fill="url(#paint124_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M124.341 63.084L97.1752 119.341H96.8887L124.068 63.084H124.341Z"
          fill="url(#paint125_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M124.628 63.084L97.4623 119.341H97.1758L124.341 63.084H124.628Z"
          fill="url(#paint126_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M124.915 63.084L97.7494 119.341H97.4629L124.629 63.084H124.915Z"
          fill="url(#paint127_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M125.2 63.084L98.0346 119.341H97.748L124.914 63.084H125.2Z"
          fill="url(#paint128_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M125.474 63.084L98.308 119.341H98.0352L125.201 63.084H125.474Z"
          fill="url(#paint129_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M125.761 63.084L98.5951 119.341H98.3086L125.474 63.084H125.761Z"
          fill="url(#paint130_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M126.046 63.084L98.8803 119.341H98.5938L125.759 63.084H126.046Z"
          fill="url(#paint131_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M126.333 63.084L99.1674 119.341H98.8809L126.047 63.084H126.333Z"
          fill="url(#paint132_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M126.607 63.084L99.4409 119.341H99.168L126.334 63.084H126.607Z"
          fill="url(#paint133_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M126.894 63.084L99.7279 119.341H99.4414L126.607 63.084H126.894Z"
          fill="url(#paint134_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M127.179 63.084L100.013 119.341H99.7266L126.892 63.084H127.179Z"
          fill="url(#paint135_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M127.466 63.084L100.3 119.341H100.014L127.179 63.084H127.466Z"
          fill="url(#paint136_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M127.751 63.084L100.585 119.341H100.299L127.464 63.084H127.751Z"
          fill="url(#paint137_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.024 63.084L100.859 119.341H100.586L127.752 63.084H128.024Z"
          fill="url(#paint138_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 63.1252L101.146 119.341H100.859L128.025 63.084H128.298V63.1252Z"
          fill="url(#paint139_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 63.7156L101.433 119.341H101.146L128.298 63.125V63.7156Z"
          fill="url(#paint140_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 64.2927L101.72 119.341H101.434L128.299 63.7158V64.2927Z"
          fill="url(#paint141_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 64.8836L101.992 119.341H101.719L128.298 64.293V64.8836Z"
          fill="url(#paint142_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 65.4734L102.279 119.34H101.992L128.298 64.8828V65.4734Z"
          fill="url(#paint143_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 66.0642L102.566 119.341H102.279L128.299 65.4736V66.0642Z"
          fill="url(#paint144_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.297 66.6413L102.851 119.341H102.564L128.297 66.0645V66.6413Z"
          fill="url(#paint145_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 67.2312L103.138 119.34H102.852L128.298 66.6406V67.2312Z"
          fill="url(#paint146_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 67.822L103.412 119.34H103.139L128.299 67.2314V67.822Z"
          fill="url(#paint147_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 68.3991L103.699 119.341H103.412L128.299 67.8223V68.3991Z"
          fill="url(#paint148_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 68.99L103.984 119.341H103.697L128.298 68.3994V68.99Z"
          fill="url(#paint149_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 69.5798L104.271 119.34H103.984L128.298 68.9893V69.5798Z"
          fill="url(#paint150_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.297 70.1707L104.542 119.34H104.27L128.297 69.5801V70.1707Z"
          fill="url(#paint151_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.3 70.7477L104.831 119.341H104.545L128.3 70.1709V70.7477Z"
          fill="url(#paint152_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 71.3386L105.117 119.341H104.83L128.298 70.748V71.3386Z"
          fill="url(#paint153_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 71.9285L105.404 119.34H105.117L128.299 71.3379V71.9285Z"
          fill="url(#paint154_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 72.5193L105.691 119.34H105.404L128.299 71.9287V72.5193Z"
          fill="url(#paint155_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 73.0964L105.962 119.341H105.689L128.298 72.5195V73.0964Z"
          fill="url(#paint156_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 73.6873L106.249 119.341H105.963L128.298 73.0967V73.6873Z"
          fill="url(#paint157_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 74.2771L106.537 119.34H106.25L128.299 73.6865V74.2771Z"
          fill="url(#paint158_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 74.8679L106.822 119.34H106.535L128.298 74.2773V74.8679Z"
          fill="url(#paint159_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 75.445L107.095 119.341H106.822L128.298 74.8682V75.445Z"
          fill="url(#paint160_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 76.0349L107.382 119.34H107.096L128.299 75.4443V76.0349Z"
          fill="url(#paint161_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 76.6257L107.669 119.34H107.383L128.299 76.0352V76.6257Z"
          fill="url(#paint162_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 77.2175L107.954 119.341H107.668L128.298 76.627V77.2175Z"
          fill="url(#paint163_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 77.7936L108.242 119.341H107.955L128.299 77.2168V77.7936Z"
          fill="url(#paint164_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.297 78.3845L108.513 119.341H108.24L128.297 77.7939V78.3845Z"
          fill="url(#paint165_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 78.9754L108.8 119.341H108.514L128.298 78.3848V78.9754Z"
          fill="url(#paint166_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 79.5652L109.087 119.34H108.801L128.298 78.9746V79.5652Z"
          fill="url(#paint167_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 80.1423L109.374 119.341H109.088L128.299 79.5654V80.1423Z"
          fill="url(#paint168_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 80.7332L109.646 119.341H109.373L128.298 80.1426V80.7332Z"
          fill="url(#paint169_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 81.323L109.933 119.34H109.646L128.298 80.7324V81.323Z"
          fill="url(#paint170_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 81.9001L110.22 119.341H109.934L128.299 81.3232V81.9001Z"
          fill="url(#paint171_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 82.491L110.507 119.341H110.221L128.299 81.9004V82.491Z"
          fill="url(#paint172_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 83.0808L110.779 119.34H110.506L128.298 82.4902V83.0808Z"
          fill="url(#paint173_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.297 83.6716L111.064 119.34H110.777L128.297 83.0811V83.6716Z"
          fill="url(#paint174_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 84.2478L111.353 119.34H111.066L128.299 83.6709V84.2478Z"
          fill="url(#paint175_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.3 84.8386L111.64 119.34H111.354L128.3 84.248V84.8386Z"
          fill="url(#paint176_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 85.4295L111.925 119.34H111.639L128.298 84.8389V85.4295Z"
          fill="url(#paint177_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 86.0203L112.199 119.34H111.926L128.299 85.4297V86.0203Z"
          fill="url(#paint178_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 86.5974L112.486 119.341H112.199L128.299 86.0205V86.5974Z"
          fill="url(#paint179_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 87.1882L112.771 119.341H112.484L128.298 86.5977V87.1882Z"
          fill="url(#paint180_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 87.7781L113.058 119.34H112.771L128.299 87.1875V87.7781Z"
          fill="url(#paint181_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 88.3679L113.331 119.339H113.059L128.299 87.7773V88.3679Z"
          fill="url(#paint182_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 88.946L113.617 119.341H113.33L128.298 88.3691V88.946Z"
          fill="url(#paint183_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.298 89.5369L113.904 119.341H113.617L128.298 88.9463V89.5369Z"
          fill="url(#paint184_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M128.299 90.1267L114.191 119.34H113.904L128.299 89.5361V90.1267Z"
          fill="url(#paint185_linear_1563_101126)"
        />
        <path
          opacity="0.2"
          d="M114.189 119.34L128.298 90.127V119.34H114.189Z"
          fill="url(#paint186_linear_1563_101126)"
        />
      </g>
      <mask
        id="mask5_1563_101126"
        maskUnits="userSpaceOnUse"
        x="82"
        y="61"
        width="46"
        height="62"
      >
        <path
          d="M83.5459 122.293V88.6979C83.5459 88.0386 84.0098 87.2145 84.5828 86.8849L127.262 62.0803C127.548 61.9155 127.808 61.9017 127.985 62.0116L126.552 61.1875C126.361 61.0639 126.102 61.0777 125.802 61.2562L83.1229 86.0608C82.5498 86.3905 82.0859 87.2008 82.0859 87.8738V121.469C82.0859 121.812 82.2087 122.045 82.4134 122.155L83.8324 122.966C83.655 122.856 83.5459 122.622 83.5459 122.306V122.293Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask5_1563_101126)">
        <path
          d="M82.0859 114.053L90.2042 119.478L87.912 122.953H82.0859V114.053Z"
          fill="#ACB0C8"
        />
        <path
          d="M82.0859 93.5195L99.6051 105.221L90.2042 119.478L82.0859 114.053V93.5195Z"
          fill="#ACB0C8"
        />
        <path
          d="M82.0859 93.2031L99.7416 105.001L99.6051 105.221L82.0859 93.519V93.2031Z"
          fill="#ACB0C8"
        />
        <path
          d="M82.0859 92.8877L99.8917 104.796L99.7416 105.002L82.0859 93.2036V92.8877Z"
          fill="#ADB1C9"
        />
        <path
          d="M82.0859 92.5859L100.028 104.576L99.8917 104.796L82.0859 92.8881V92.5859Z"
          fill="#AEB3CA"
        />
        <path
          d="M82.0859 92.2695L100.178 104.356L100.028 104.576L82.0859 92.5854V92.2695Z"
          fill="#B0B4CB"
        />
        <path
          d="M82.0859 91.9541L100.315 104.137L100.178 104.356L82.0859 92.27V91.9541Z"
          fill="#B1B5CD"
        />
        <path
          d="M82.0859 91.6514L100.465 103.93L100.315 104.136L82.0859 91.9535V91.6514Z"
          fill="#B2B6CE"
        />
        <path
          d="M82.0859 91.3359L100.601 103.711L100.465 103.931L82.0859 91.6518V91.3359Z"
          fill="#B4B8CF"
        />
        <path
          d="M82.0859 91.0195L100.751 103.491L100.601 103.71L82.0859 91.3354V91.0195Z"
          fill="#B5B9D0"
        />
        <path
          d="M82.0859 90.7178L100.888 103.271L100.751 103.491L82.0859 91.0199V90.7178Z"
          fill="#B6BAD1"
        />
        <path
          d="M82.0859 90.4014L101.024 103.065L100.888 103.271L82.0859 90.7173V90.4014Z"
          fill="#B7BBD2"
        />
        <path
          d="M82.0859 90.0859L101.174 102.845L101.024 103.065L82.0859 90.4018V90.0859Z"
          fill="#B9BDD4"
        />
        <path
          d="M82.0859 89.7832L101.311 102.625L101.174 102.845L82.0859 90.0854V89.7832Z"
          fill="#BABED5"
        />
        <path
          d="M82.0859 89.4678L101.461 102.406L101.311 102.625L82.0859 89.7837V89.4678Z"
          fill="#BBBFD6"
        />
        <path
          d="M82.0859 89.1514L101.597 102.199L101.461 102.405L82.0859 89.4673V89.1514Z"
          fill="#BCC0D7"
        />
        <path
          d="M82.0859 88.8359L101.747 101.98L101.597 102.2L82.0859 89.1518V88.8359Z"
          fill="#BEC1D8"
        />
        <path
          d="M82.0859 88.5332L101.884 101.76L101.747 101.979L82.0859 88.8354V88.5332Z"
          fill="#BFC3D9"
        />
        <path
          d="M82.0859 88.2188L102.034 101.555L101.884 101.761L82.0859 88.5346V88.2188Z"
          fill="#C0C4DA"
        />
        <path
          d="M82.0859 87.9014L102.17 101.334L102.034 101.554L82.0859 88.2173V87.9014Z"
          fill="#C1C5DB"
        />
        <path
          d="M82.0859 87.5996L102.32 101.114L102.17 101.334L82.0859 87.9018V87.5996Z"
          fill="#C2C6DC"
        />
        <path
          d="M82.0859 87.2842L102.457 100.895L102.32 101.115L82.0859 87.6001V87.2842Z"
          fill="#C3C7DD"
        />
        <path
          d="M82.0859 86.9678L102.593 100.689L102.457 100.895L82.0859 87.2837V86.9678Z"
          fill="#C4C8DE"
        />
        <path
          d="M82.0859 86.8992L82.1951 86.7344L102.743 100.469L102.593 100.689L82.0859 86.9679V86.8992Z"
          fill="#C5C9DF"
        />
        <path
          d="M82.3348 86.517L82.1914 86.7344L102.741 100.473L102.884 100.255L82.3348 86.517Z"
          fill="#C6CAE0"
        />
        <path
          d="M82.4755 86.309L82.332 86.5264L102.882 100.265L103.025 100.047L82.4755 86.309Z"
          fill="#C7CBE1"
        />
        <path
          d="M82.6317 86.0824L82.4883 86.2998L103.038 100.038L103.181 99.8207L82.6317 86.0824Z"
          fill="#C8CCE2"
        />
        <path
          d="M82.7723 85.8744L82.6289 86.0918L103.178 99.8301L103.322 99.6127L82.7723 85.8744Z"
          fill="#C9CDE3"
        />
        <path
          d="M82.9188 85.6537L82.7754 85.8711L103.325 99.6093L103.468 99.392L82.9188 85.6537Z"
          fill="#CACEE4"
        />
        <path
          d="M83.0555 85.4389L82.9121 85.6562L103.462 99.3945L103.605 99.1771L83.0555 85.4389Z"
          fill="#CBCFE4"
        />
        <path
          d="M83.202 85.2201L83.0586 85.4375L103.608 99.1758L103.752 98.9584L83.202 85.2201Z"
          fill="#CBD0E5"
        />
        <path
          d="M83.3407 85.0111L83.1973 85.2285L103.747 98.9668L103.89 98.7494L83.3407 85.0111Z"
          fill="#CCD1E6"
        />
        <path
          d="M83.4813 84.7885L83.3379 85.0059L103.887 98.7441L104.031 98.5267L83.4813 84.7885Z"
          fill="#CDD1E7"
        />
        <path
          d="M83.6258 84.5766L83.4824 84.7939L104.032 98.5322L104.175 98.3148L83.6258 84.5766Z"
          fill="#CED2E8"
        />
        <path
          d="M83.7645 84.3676L83.6211 84.585L104.171 98.3232L104.314 98.1058L83.7645 84.3676Z"
          fill="#CED3E8"
        />
        <path
          d="M83.911 84.1342L83.7676 84.3516L104.317 98.0898L104.461 97.8724L83.911 84.1342Z"
          fill="#CFD4E9"
        />
        <path
          d="M84.0497 83.9252L83.9062 84.1426L104.456 97.8808L104.599 97.6634L84.0497 83.9252Z"
          fill="#D0D5EA"
        />
        <path
          d="M84.2079 83.7133L84.0645 83.9307L104.614 97.6689L104.757 97.4515L84.2079 83.7133Z"
          fill="#D1D5EA"
        />
        <path
          d="M84.3348 83.4906L84.1914 83.708L104.741 97.4463L104.884 97.2289L84.3348 83.4906Z"
          fill="#D1D6EB"
        />
        <path
          d="M84.4813 83.2719L84.3379 83.4893L104.887 97.2275L105.031 97.0101L84.4813 83.2719Z"
          fill="#D2D7EC"
        />
        <path
          d="M84.62 83.0629L84.4766 83.2803L105.026 97.0185L105.169 96.8011L84.62 83.0629Z"
          fill="#D2D7EC"
        />
        <path
          d="M84.7704 82.848L84.627 83.0654L105.176 96.8037L105.32 96.5863L84.7704 82.848Z"
          fill="#D3D8ED"
        />
        <path
          d="M84.9051 82.6283L84.7617 82.8457L105.311 96.584L105.455 96.3666L84.9051 82.6283Z"
          fill="#D4D9ED"
        />
        <path
          d="M85.0419 82.4203L84.8984 82.6377L105.448 96.376L105.591 96.1586L85.0419 82.4203Z"
          fill="#D4D9EE"
        />
        <path
          d="M85.1903 82.1859L85.0469 82.4033L105.596 96.1416L105.74 95.9242L85.1903 82.1859Z"
          fill="#D5DAEE"
        />
        <path
          d="M85.3407 81.9848L85.1973 82.2021L105.747 95.9404L105.89 95.723L85.3407 81.9848Z"
          fill="#D5DAEF"
        />
        <path
          d="M85.4872 81.765L85.3438 81.9824L105.893 95.7207L106.037 95.5033L85.4872 81.765Z"
          fill="#D6DBEF"
        />
        <path
          d="M85.6141 81.5424L85.4707 81.7598L106.02 95.498L106.164 95.2806L85.6141 81.5424Z"
          fill="#D6DBF0"
        />
        <path
          d="M85.7587 81.3227L85.6152 81.54L106.165 95.2783L106.308 95.0609L85.7587 81.3227Z"
          fill="#D6DBF0"
        />
        <path
          d="M85.911 81.1215L85.7676 81.3389L106.317 95.0771L106.461 94.8597L85.911 81.1215Z"
          fill="#D7DCF0"
        />
        <path
          d="M86.0575 80.8881L85.9141 81.1055L106.464 94.8437L106.607 94.6263L86.0575 80.8881Z"
          fill="#D7DCF0"
        />
        <path
          d="M86.1962 80.6791L86.0527 80.8965L106.602 94.6347L106.746 94.4174L86.1962 80.6791Z"
          fill="#D7DCF1"
        />
        <path
          d="M86.3329 80.4789L86.1895 80.6963L106.739 94.4345L106.882 94.2172L86.3329 80.4789Z"
          fill="#D7DCF1"
        />
        <path
          d="M86.3301 80.4577L99.1284 61.0645H127.986V62.2044L106.878 94.1922L86.3301 80.4577Z"
          fill="#D7DCF1"
        />
      </g>
      <path
        d="M121.626 115.563L113.672 111.964C111.898 111.099 110.629 109.684 109.851 108.215L100.969 113.379C101.733 115.989 103.67 117.829 103.67 117.829C103.67 117.829 108.555 121.634 109.837 122.499C111.12 123.364 112.498 122.636 112.498 122.636L121.64 117.115C121.64 117.115 122.145 116.868 122.267 116.483L122.295 116.359C122.349 115.879 121.64 115.563 121.64 115.563H121.626Z"
        fill="white"
      />
      <path
        d="M121.626 117.115L112.485 122.636C112.485 122.636 111.107 123.364 109.824 122.499C108.542 121.633 103.657 117.829 103.657 117.829C103.657 117.829 101.72 115.975 100.955 113.379L100.191 113.818C100.71 115.549 101.856 117.238 103.793 118.639C109.292 122.609 109.879 122.924 109.879 122.924C109.879 122.924 110.82 123.748 112.526 122.924C114.231 122.1 121.695 117.444 121.695 117.444C121.695 117.444 122.309 117.101 122.309 116.785L122.281 116.304C122.309 116.785 121.626 117.115 121.626 117.115Z"
        fill="white"
      />
      <g opacity="0.3">
        <path
          d="M121.626 117.115L112.485 122.636C112.485 122.636 111.107 123.364 109.824 122.499C108.542 121.633 103.657 117.829 103.657 117.829C103.657 117.829 101.72 115.975 100.955 113.379L100.191 113.818C100.71 115.549 101.856 117.238 103.793 118.639C109.292 122.609 109.879 122.924 109.879 122.924C109.879 122.924 110.82 123.748 112.526 122.924C114.231 122.1 121.695 117.444 121.695 117.444C121.695 117.444 122.309 117.101 122.309 116.785L122.281 116.304C122.309 116.785 121.626 117.115 121.626 117.115Z"
          fill="#4A85C5"
        />
      </g>
      <g opacity="0.2">
        <path
          d="M109.851 108.215L100.969 113.379C101.446 115 102.374 116.318 103.015 117.101L112.757 111.442C111.461 110.577 110.492 109.423 109.865 108.215H109.851Z"
          fill="#4A85C5"
        />
      </g>
      <mask
        id="mask6_1563_101126"
        maskUnits="userSpaceOnUse"
        x="85"
        y="49"
        width="55"
        height="69"
      >
        <path
          d="M139.637 86.3115L85.7011 117.654L85.6602 68.745L124.533 49.2969L139.637 86.3115Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask6_1563_101126)">
        <path
          d="M131.847 86.487C131.71 85.9239 131.287 84.3856 131.451 84.3307C131.615 84.2758 131.806 84.2758 132.052 84.4406C132.052 84.5505 132.543 85.141 132.597 85.3745C132.652 85.608 132.775 86.6244 132.734 86.7617C132.734 86.8167 132.584 86.9677 132.406 87.16C132.161 86.9952 131.915 86.7617 131.847 86.487Z"
          fill="#F7B8AF"
        />
        <path
          d="M125.502 84.2072C125.966 84.0286 126.457 82.9436 126.771 82.6964C127.084 82.4491 128.408 82.2019 128.967 82.0234C129.527 81.8448 130.823 81.5564 131.314 81.5839C131.805 81.6113 133.948 81.7899 134.425 81.9135C134.903 82.0371 134.916 82.5315 134.548 82.6826C134.179 82.8337 133.361 82.7925 132.938 82.7925C132.515 82.7925 131.56 82.765 131.587 82.8337C131.614 82.9024 132.351 83.0809 132.597 83.2457C132.842 83.4106 133.265 83.8913 133.484 84.4818C133.688 85.0724 133.716 85.4982 133.456 85.6493C133.429 85.663 133.402 85.6768 133.388 85.6905C133.347 85.3746 133.224 84.8802 132.897 84.4956C132.392 83.9187 131.71 83.4792 131.11 83.3007C130.509 83.1221 130.277 82.4491 129.895 82.3667C129.527 82.2706 128.667 82.2981 128.79 82.4354C128.913 82.5727 129.39 82.971 129.308 83.1771C129.227 83.3831 129.24 83.5754 129.377 84.0286C129.513 84.4956 129.295 84.6192 128.804 84.578C128.312 84.5368 127.576 84.317 127.207 83.7951C126.839 83.2732 126.593 83.7951 126.389 84.0835C126.17 84.372 125.925 84.7291 125.925 84.7291L126.348 86.4047C126.061 86.4459 125.884 86.4871 125.884 86.4871C125.884 86.4871 125.065 84.3994 125.529 84.2209L125.502 84.2072Z"
          fill="#F8C2BD"
        />
        <path
          d="M131.998 87.5304C131.807 87.6815 131.616 87.8188 131.493 87.8326C131.138 87.8875 130.934 87.8051 131.07 87.3931C131.152 87.1596 131.261 86.981 131.343 86.8574C131.507 87.1046 131.766 87.3519 131.984 87.5304H131.998Z"
          fill="#F7B8AF"
        />
        <path
          d="M126.374 84.0696C126.592 83.7811 126.838 83.273 127.193 83.7811C127.561 84.3031 128.298 84.5228 128.789 84.564C129.28 84.6052 129.499 84.4816 129.362 84.0146C129.226 83.5477 129.212 83.3691 129.294 83.1631C129.376 82.9571 128.898 82.5588 128.775 82.4214C128.653 82.2841 129.512 82.2703 129.881 82.3527C130.249 82.4489 130.495 83.1082 131.095 83.2867C131.695 83.4652 132.377 83.9048 132.882 84.4816C133.223 84.8662 133.333 85.3606 133.373 85.6765C133.155 85.7589 132.964 85.6216 132.841 85.3469C132.705 85.0447 132.473 84.5778 132.391 84.4953C132.309 84.4129 132.023 84.3031 132.036 84.4129C131.791 84.2481 131.613 84.2481 131.436 84.3031C131.259 84.358 131.695 85.8963 131.832 86.4594C131.9 86.7341 132.146 86.9676 132.391 87.1324C132.268 87.256 132.118 87.3933 131.968 87.5169C131.75 87.3384 131.477 87.0912 131.327 86.844C131.381 86.7478 131.422 86.6929 131.395 86.6654C131.327 86.5967 131.354 86.2534 130.017 86.0886C129.007 85.9649 127.165 86.2259 126.306 86.3632L125.883 84.6876C125.883 84.6876 126.142 84.3305 126.347 84.0421L126.374 84.0696Z"
          fill="#F4A29B"
        />
        <path
          d="M106.768 73.2477C106.768 73.2477 107.354 73.2202 108.691 72.973C109.728 72.7807 110.397 72.6296 112.116 75.7199C112.771 76.9148 117.492 84.4001 117.492 84.4001L126.088 83.576C126.088 83.576 126.129 84.3177 126.265 85.0731C125.842 85.1418 125.296 85.2517 124.601 85.4577C122.336 86.1169 119.047 87.2569 118.256 86.9685C117.465 86.68 117.192 86.4054 117.396 85.5538C117.396 85.1418 117.328 85.3615 116.987 85.5813C116.632 85.801 116.196 86.323 115.95 85.6088C115.705 84.8946 113.508 80.8429 111.993 79.3183C110.479 77.7801 110.165 76.3654 110.165 76.3654L109.633 77.835V78.5629L109.128 77.5054L106.768 73.2751V73.2477Z"
          fill="#F3F9FF"
        />
        <path
          d="M110.14 76.0499C110.14 76.0499 110.467 77.7668 111.982 79.2913C113.496 80.8296 115.693 84.8675 115.938 85.5817C116.184 86.2959 116.621 85.774 116.975 85.5543C117.33 85.3345 117.385 85.1285 117.385 85.5268C117.18 86.3783 117.453 86.653 118.244 86.9414C119.036 87.2299 122.324 86.0762 124.589 85.4306C125.285 85.2246 125.83 85.1147 126.253 85.0461C126.349 85.5955 126.485 86.1311 126.676 86.3921C118.367 89.0566 117.644 89.0978 117.644 89.0978C117.644 89.0978 116.552 89.4137 115.829 88.5072C115.106 87.6144 112.555 84.4555 112.555 84.4555L109.648 78.5084V77.7805L110.14 76.0225V76.0499Z"
          fill="#E2F1FB"
        />
        <path
          d="M99.0727 100.058C99.0727 100.058 99.0317 101.843 98.9771 102.489C98.9226 103.134 99.0727 111.265 99.5775 116.594C100.096 121.923 99.673 122.472 99.4547 123.516C99.2364 124.56 98.2813 127.747 98.0903 129.807C97.8993 131.867 97.3398 141.783 97.3398 141.783L104.394 142.525C104.394 142.525 104.694 130.329 105.499 126.222C106.304 122.115 106.495 120.687 106.645 117.844C106.795 115.001 106.904 114.452 106.904 114.452C106.904 114.452 107.136 117.789 107.123 120.083C107.123 122.376 107.055 124.382 107.191 126.373C107.218 127.087 107.191 130.287 107.041 131.565C106.891 132.842 106.986 140.863 106.986 140.863C106.986 140.863 110.22 143.775 114.177 141.124C113.999 138.926 113.14 128.378 113.126 125.824C113.113 123.269 113.74 121.003 114.122 117.418C114.504 113.833 115.746 103.052 113.863 98.5469L99.059 100.071L99.0727 100.058Z"
          fill="#102743"
        />
        <path
          d="M102.757 101.677C102.757 101.677 103.235 98.7515 104.258 98.1472C105.281 97.5429 108.87 97.8451 109.579 97.5704C110.289 97.2957 111.217 95.9222 111.217 95.9222L107.424 94.4114C107.424 94.4114 105.431 93.917 104.64 93.6011C103.849 93.2852 103.74 92.7633 104.094 92.0903C104.449 91.4036 106.441 90.0713 106.441 90.0713C106.441 90.0713 104.913 90.3735 102.976 89.3983C101.052 88.4369 101.638 86.308 101.584 85.1406C101.529 83.9732 99.7555 82.5173 99.7555 82.5173L98.4047 84.2341C97.9544 83.3276 97.6406 82.7783 97.6406 82.7783L99.3462 76.2543C99.3462 76.2543 105.868 72.6284 107.71 73.3563C109.552 74.0843 110.657 76.7488 110.657 76.7488C110.657 76.7488 110.521 78.7128 112.131 80.4296C113.741 82.1465 114.314 83.3688 114.055 84.9483C113.795 86.5278 112.335 87.2145 112.335 87.2145C112.335 87.2145 111.981 88.7665 111.899 89.5769C111.817 90.3872 112.158 91.8019 112.813 94.1505C113.468 96.5128 114.341 97.6253 114.341 97.6253C113.686 99.5344 111.967 101.073 107.942 102.034C103.917 102.996 98.9368 101.375 98.9368 101.375C98.9368 101.375 98.9641 100.99 99.0323 100.4C100.001 101.265 102.744 101.663 102.744 101.663L102.757 101.677Z"
          fill="#F3F9FF"
        />
        <path
          d="M101.583 85.1146C101.638 86.282 101.051 88.4109 102.975 89.3723C104.899 90.3337 106.441 90.0453 106.441 90.0453C106.441 90.0453 104.449 91.3775 104.094 92.0643C103.739 92.751 103.835 93.2592 104.64 93.5751C105.431 93.891 107.423 94.3854 107.423 94.3854L111.216 95.8962C111.216 95.8962 110.288 97.2697 109.579 97.5444C108.869 97.819 105.281 97.5169 104.258 98.1212C103.234 98.7255 103.589 102.255 103.589 102.255C103.589 102.255 100.028 101.953 98.9501 101.363C98.9637 100.415 99.223 98.8079 99.4003 97.8877C99.7278 96.1572 101.351 93.9871 101.106 91.9269C100.656 89.0427 99.2775 85.9661 98.4043 84.1944L99.7551 82.4775C99.7551 82.4775 101.529 83.9334 101.583 85.1008V85.1146Z"
          fill="#E2F1FB"
        />
        <path
          d="M106.687 71.6404L106.523 73.2611L107.314 79.4553L103.385 76.8733L101.488 74.4972C101.488 74.4972 102.239 74.2774 101.898 72.8353C100.888 68.4814 106.687 71.6404 106.687 71.6404Z"
          fill="#F8C2BD"
        />
        <path
          d="M106.632 72.8356C106.632 72.8356 106.413 73.2202 105.813 73.1653C105.213 73.1103 103.098 73.3988 102.061 72.3412C101.01 71.2836 101.774 70.8853 101.774 70.8853L103.807 70.7617C103.807 70.7617 104.626 72.2313 104.776 72.2863C104.926 72.3412 106.632 72.8082 106.632 72.8082V72.8356Z"
          fill="#F7B8AF"
        />
        <path
          d="M110.083 103.258C110.083 103.258 108.978 105.249 107.45 106.458L106.877 112.68L107.177 129.065L109.333 127.417C109.333 127.417 108.269 118.187 108.269 113.408C108.269 110.166 108.214 107.667 108.542 106.65C108.869 105.634 110.001 104.096 110.083 103.258Z"
          fill="#061930"
        />
        <path
          d="M113.782 93.4512C113.782 93.4512 113.946 93.8083 113.823 94.138C113.7 94.4676 113.85 94.4951 113.782 94.756C113.714 95.017 113.755 95.0444 113.714 95.2093C113.673 95.3741 112.827 95.9647 112.24 96.4316C111.654 96.8986 111.572 97.036 110.944 97.1321C110.316 97.2282 109.58 97.2969 108.461 97.2145C107.342 97.1321 105.623 97.1321 105.623 97.1321L105.541 95.7037L111.435 94.7835L113.768 93.4375L113.782 93.4512Z"
          fill="#F4A29B"
        />
        <path
          d="M105.309 94.8253C105.309 94.8253 107.233 94.4819 107.983 94.1248C108.734 93.7677 111.326 92.8612 111.558 93.2733C112.035 94.1248 110.043 94.0149 110.084 94.1523C110.125 94.2896 110.821 94.221 111.585 93.9737C112.131 93.8089 113.277 92.8338 113.577 92.7651C113.877 92.6964 113.987 92.8338 113.959 93.2046C113.932 93.5754 113.468 93.8639 112.677 94.3858C111.885 94.9077 111.176 95.1549 110.739 95.6493C110.303 96.1438 109.907 96.3498 109.443 96.4185C108.979 96.4872 105.554 96.8305 105.145 96.2949C104.736 95.7592 105.322 94.8115 105.322 94.8115L105.309 94.8253Z"
          fill="#F8C2BD"
        />
        <path
          d="M100.369 74.9366C100.369 74.9366 97.1349 76.8594 96.6437 77.3127C96.1525 77.7659 95.5385 79.7574 95.4021 80.7326C95.2656 81.7077 92.3185 94.1924 92.3185 94.1924C92.3185 94.1924 91.5271 97.4613 93.5737 97.7222C95.6204 97.9832 105.949 97.6398 105.949 97.6398C105.949 97.6398 106.44 96.2801 105.894 94.7968L96.8074 93.8491L99.3452 85.7869L101.788 80.348L100.369 74.9229V74.9366Z"
          fill="#F3F9FF"
        />
        <path
          d="M107.314 79.4684L103.152 81.4737C103.152 81.4737 103.098 81.6797 102.934 81.3913C102.77 81.1028 100.532 77.0924 100.164 75.0596C100.819 74.6064 101.788 73.9746 101.788 73.9746C102.156 74.73 105.731 78.2323 107.314 79.4684Z"
          fill="white"
        />
        <path
          d="M103.546 67.8361C103.614 67.424 103.696 67.0257 103.805 66.6274C103.914 66.2154 104.01 65.8171 104.092 65.3913C104.242 64.6084 104.419 63.8256 104.788 63.1114C105.183 62.3834 107.653 62.1637 108.308 62.4384C109.017 62.7405 109.454 63.1388 109.563 63.5234C109.672 63.908 109.932 64.526 109.891 65.9819C109.863 66.9708 109.959 67.5614 110.068 67.9459C110.382 69.1134 110.245 69.4842 110.245 69.4842C110.054 69.4293 109.891 69.0447 109.891 69.0447C109.891 69.9237 110.368 70.0336 110.368 70.0336C110.327 70.1572 110.082 70.2121 109.781 70.1572C109.754 70.1572 109.727 70.1572 109.7 70.1435C109.672 70.3495 109.631 70.5418 109.577 70.7066C108.895 72.4509 108.049 72.7805 108.049 72.7805C108.049 72.7805 106.848 72.8354 106.834 72.6981C106.834 72.6981 106.834 72.6706 106.834 72.6569C105.866 72.5333 104.556 72.3135 104.365 72.0663C104.242 71.9152 104.105 71.7641 103.996 71.6131C103.887 71.4483 103.792 71.2834 103.71 71.1049C103.56 70.7753 103.478 70.4182 103.423 70.0611C103.341 69.3331 103.423 68.5777 103.56 67.8635L103.546 67.8361Z"
          fill="#090200"
        />
        <path
          d="M106.998 62.439C108.799 63.263 108.963 64.5953 109.55 66.1885C109.672 66.5319 109.372 66.9164 109.331 67.1636C109.304 67.3971 109.713 68.0015 109.618 69.0865C109.536 69.9243 109.359 70.3363 109.181 71.0505C109.099 71.3802 108.922 71.7235 108.786 72.0531C108.485 72.7948 108.376 72.891 108.158 72.9871C107.858 73.1107 107.176 73.0832 106.944 73.042C106.425 72.9459 104.624 72.4652 104.01 71.9295C103.383 71.3939 103.028 70.817 102.987 69.0865C102.987 69.0865 101.104 68.6607 100.667 67.1499C100.272 65.8177 100.845 62.3565 102.987 61.7797C105.115 61.2166 105.293 61.6561 106.998 62.439Z"
          fill="#F8C2BD"
        />
        <path
          d="M108.663 69.0998C108.663 69.0998 108.622 68.9899 108.54 68.8389C108.581 68.9625 108.622 69.141 108.717 69.3883C108.717 69.3883 108.69 69.4569 108.567 69.5531C108.403 69.6767 108.363 69.6492 108.144 69.5943C108.103 69.5943 108.021 69.5805 107.926 69.5943C107.789 69.6355 107.558 69.6767 107.421 69.7041C107.23 69.7453 107.08 69.6492 107.025 69.4981C107.025 69.5531 107.025 69.6355 107.053 69.6767C107.066 69.7179 107.107 69.7591 107.162 69.8003C107.23 69.8552 107.298 69.8827 107.394 69.8964C107.544 69.9376 107.639 69.9514 107.912 69.9376C107.912 69.9376 107.98 69.9514 108.103 69.9651C108.226 69.9651 108.322 69.9376 108.322 69.9376C108.322 69.9376 108.581 69.6904 108.717 69.5256C108.813 69.4157 108.813 69.402 108.649 69.0724L108.663 69.0998Z"
          fill="#F7B8AF"
        />
        <path
          d="M108.391 69.8836C108.391 69.8836 108.582 69.7188 108.65 69.6364C108.65 69.554 108.432 69.7051 108.391 69.8836Z"
          fill="#F4A29B"
        />
        <path
          d="M107.463 69.856C107.463 69.856 107.763 69.7461 107.886 69.7461C107.995 69.7461 108.077 69.7736 108.077 69.8285C108.077 69.8834 107.954 69.8972 107.845 69.8834C107.708 69.8697 107.436 69.8834 107.477 69.8422L107.463 69.856Z"
          fill="#F4A29B"
        />
        <path
          d="M108.05 69.7874C108.05 69.7874 107.777 69.6775 107.463 69.856C107.463 69.856 107.777 69.7736 107.927 69.8286C108.022 69.856 108.131 69.8698 108.05 69.7874Z"
          fill="#F4A29B"
        />
        <path
          d="M106.547 67.6991C106.547 67.6991 106.588 67.3557 106.206 67.1772C106.001 67.081 105.578 67.1085 105.292 67.2596C105.114 67.3557 104.869 67.548 104.65 67.5755C104.65 67.5755 105.319 67.6441 105.865 67.342C106.001 67.2733 106.192 67.342 106.356 67.5068"
          fill="#090200"
        />
        <path
          d="M105.414 67.576C105.414 67.8781 105.66 68.0017 105.864 68.0017C106.069 68.0017 106.233 67.8095 106.219 67.5897C106.219 67.37 106.042 67.1914 105.837 67.1914C105.632 67.1914 105.414 67.3562 105.4 67.576H105.414Z"
          fill="#090200"
        />
        <path
          d="M109.236 67.2056C109.318 67.3018 109.455 67.3018 109.536 67.2468C109.536 67.2468 109.386 67.1781 109.277 67.0408C109.154 66.876 108.936 66.9035 108.827 66.9309C108.663 66.9859 108.499 67.0683 108.363 67.1919C108.295 67.2605 108.227 67.3842 108.213 67.5352C108.213 67.5902 108.24 67.6314 108.213 67.6726C108.281 67.5764 108.322 67.4528 108.431 67.3567C108.936 66.9309 109.236 67.2056 109.236 67.2056Z"
          fill="#090200"
        />
        <path
          d="M108.514 67.4244C108.527 67.603 108.664 67.7266 108.827 67.7266C108.978 67.7266 109.114 67.548 109.1 67.3832C109.087 67.2047 109.005 67.0811 108.814 67.0948C108.664 67.0948 108.514 67.2596 108.527 67.4382L108.514 67.4244Z"
          fill="#090200"
        />
        <path
          d="M108.69 70.8853C108.69 70.8853 108.69 71.0089 108.594 71.0226C108.553 71.0226 108.471 71.0226 108.376 71.0226C108.321 71.0226 108.307 71.1325 107.994 71.16C107.898 71.16 107.434 71.0226 107.271 71.0913C107.107 71.1462 106.834 71.1463 106.807 71.16C106.807 71.16 107.516 70.6793 107.803 70.6106C107.871 70.5969 107.994 70.6106 108.076 70.6381C108.185 70.693 108.253 70.5694 108.417 70.5557C108.417 70.5557 108.69 70.5969 108.69 70.8853Z"
          fill="#E45C66"
        />
        <path
          d="M108.567 71.0217C108.417 70.9393 108.185 71.1179 108.185 71.1179C108.185 71.1179 108.035 71.1865 107.953 71.1591C107.789 71.0904 107.407 71.0355 107.326 71.0904C107.23 71.1453 106.752 71.1179 106.807 71.1453C106.875 71.1865 106.957 71.2003 107.094 71.3376C107.216 71.4475 107.38 71.5711 107.544 71.6398C107.749 71.7222 107.94 71.7359 107.994 71.7497C108.049 71.7497 108.226 71.7497 108.294 71.6947C108.308 71.6947 108.444 71.6398 108.499 71.5574C108.554 71.4887 108.635 71.3788 108.622 71.1728C108.622 71.0767 108.554 71.0217 108.554 71.0217H108.567Z"
          fill="#E45C66"
        />
        <path
          d="M108.444 70.9816C108.375 70.9816 108.334 71.0228 108.28 71.064C108.116 71.1739 107.83 71.1052 107.734 71.0914C107.57 71.0777 107.311 71.0365 107.147 71.064C106.97 71.0777 106.779 71.1052 106.602 71.064C106.711 71.2151 107.052 71.1601 107.229 71.1327C107.393 71.1052 107.666 71.1052 107.843 71.1327C107.911 71.1464 108.089 71.2013 108.307 71.0777C108.362 71.0502 108.416 71.009 108.471 71.0228C108.512 71.0228 108.744 71.064 108.771 70.9541C108.675 71.009 108.525 70.9541 108.444 70.9541V70.9816Z"
          fill="#D6455A"
        />
        <path
          d="M105.824 66.4237C106.438 66.3413 107.161 66.5748 107.106 66.6297C106.956 66.7533 106.82 66.7808 106.629 66.7396C106.356 66.6709 106.151 66.616 105.987 66.616C105.373 66.6297 105.046 66.8907 104.609 67.1104C104.609 67.1104 105.046 66.5473 105.837 66.4374L105.824 66.4237Z"
          fill="#2C2C29"
        />
        <path
          d="M108.909 66.2444C108.472 66.2581 107.981 66.6289 108.035 66.6564C108.145 66.7525 108.254 66.7525 108.39 66.6701C108.581 66.5603 108.718 66.4641 108.84 66.4366C109.277 66.3542 109.536 66.5465 109.864 66.6839C109.864 66.6839 109.495 66.2032 108.922 66.2306L108.909 66.2444Z"
          fill="#2C2C29"
        />
        <path
          d="M104.462 72.3006C104.462 72.3006 103.602 71.6551 103.384 70.625C103.152 69.5537 103.411 68.9769 103.616 68.194C103.752 67.6858 103.193 66.2574 103.193 66.2574L101.256 62.2744C101.256 62.2744 99.8365 62.6452 99.3999 64.3071C99.0452 65.6256 99.5227 69.7598 99.5227 69.7598L99.168 70.1993C99.168 70.1993 99.3044 71.0371 99.8911 72.0122C100.341 72.7402 101.051 72.85 100.969 72.7676C100.614 72.4105 100.532 72.0397 100.601 72.1496C100.846 72.5479 101.187 72.7127 101.378 72.8363C102.142 73.3582 102.265 72.9874 103.302 72.4655C103.302 72.4655 102.92 72.3006 102.634 71.971C102.634 71.971 103.22 72.8226 104.462 72.2732V72.3006Z"
          fill="#090200"
        />
        <path
          d="M105.881 61.0795C105.089 60.9147 104.011 60.6263 102.347 61.0521C100.082 61.6289 98.9357 64.1149 98.7311 65.2686C98.6219 65.8592 98.6765 66.7107 98.8402 67.4386C98.8812 67.7408 98.9767 68.3726 99.0585 68.6885C99.154 69.2516 98.39 69.6774 98.39 69.6774C98.39 69.6774 98.9357 69.7186 99.2086 69.4714C99.1813 69.8834 98.9494 70.2405 98.5537 70.4053C98.39 70.4465 98.2262 70.4877 98.0625 70.474C98.2399 70.6388 98.4718 70.7075 98.7174 70.7212C98.8266 70.7212 98.9494 70.7212 99.0585 70.6937C99.0858 70.6937 99.3587 70.6663 99.4269 70.4602C99.2905 70.7349 98.9357 71.1195 98.9357 71.1195C100.832 70.9684 102.033 68.8121 102.033 68.8121C101.76 70.007 100.955 70.3504 100.955 70.3504C101.528 70.2954 101.706 70.0482 101.937 69.9795C101.91 70.3504 102.101 70.7349 102.661 71.1058C102.661 71.1058 102.292 70.6525 102.497 69.7186C103.643 68.9494 104.544 67.3425 104.544 67.3425C104.544 67.3425 104.584 67.315 105.389 66.6283C106.263 65.9004 106.576 64.9389 106.904 63.7166C107.15 62.8101 107.723 62.3981 108.241 62.92C108.405 63.0848 108.391 62.1783 107.832 61.7388C107.477 61.4504 106.699 61.2169 105.894 61.0521L105.881 61.0795Z"
          fill="#2C2C29"
        />
        <path
          d="M107.176 62.5618C106.521 62.7953 106.371 63.331 106.207 64.1413C106.303 64.004 106.48 63.6881 106.575 63.537C107.217 62.6305 107.885 62.864 108.226 63.2074C108.226 63.07 108.09 62.7541 108.008 62.6854C107.694 62.4245 107.449 62.4657 107.162 62.5756L107.176 62.5618Z"
          fill="#090200"
        />
      </g>
      <path
        d="M141.793 145.408C141.793 145.408 141.138 140.326 141.793 138.225C142.448 136.124 143.512 135.382 146.023 135.574C148.533 135.766 156.365 139.173 156.365 139.173L152.64 150.037L141.793 145.408Z"
        fill="#2E394D"
      />
      <path
        d="M133.197 142.153C136.117 142.95 172.329 147.921 172.329 147.921C172.329 147.921 172.724 158.044 165.084 161.12C158.493 163.785 151.958 163.703 148.833 162.357C145.068 160.722 135.967 154.473 135.967 154.473C135.967 154.473 128.954 150.861 126.02 148.471C126.02 148.279 126.007 148.1 125.993 147.921C125.761 142.62 130.291 141.356 133.211 142.153H133.197Z"
        fill="#354259"
      />
      <path
        d="M173.556 111.277C173.652 111.277 175.726 109.547 175.726 109.547C175.726 109.547 178.373 111.717 179.382 114.299C180.392 116.881 182.971 124.916 183.803 126.852C184.635 128.789 184.84 134.324 182.302 135.189C179.764 136.055 170.527 131.193 170.527 131.193L173.556 111.277Z"
        fill="#353535"
      />
      <g opacity="0.5">
        <path
          d="M171.619 123.996L174.894 120.535C174.894 120.535 175.289 122.595 176.435 124.106C177.581 125.617 179.328 128.075 180.16 130.438C180.706 132.017 180.46 133.844 179.778 135.025C176.108 134.119 170.527 131.179 170.527 131.179L171.619 123.983V123.996Z"
          fill="#B5BBC7"
        />
      </g>
      <path
        d="M170.174 109.107C170.174 109.107 166.75 108.38 166.831 105.743C166.913 103.105 169.615 99.4521 169.233 95.4416C168.851 91.4311 165.549 88.7254 161.742 87.6816C157.935 86.6515 153.951 89.6593 153.31 92.0766C152.669 94.4939 152.696 95.4691 152.983 95.991C153.269 96.5129 153.296 97.2546 153.16 97.6116C153.024 97.9687 152.792 99.2323 153.105 100.304C153.419 101.375 154.265 104.96 155.125 105.248C155.984 105.536 157.24 105.605 157.444 106.718C157.649 107.83 157.171 110.481 156.503 112.157C156.503 112.157 158.972 114.491 164.607 113.557C170.243 112.624 170.161 109.107 170.161 109.107H170.174Z"
        fill="#F8C2BD"
      />
      <path
        d="M156.514 112.157C157.183 110.481 157.661 107.844 157.456 106.718C157.251 105.605 155.996 105.537 155.136 105.248C155.068 105.221 155 105.18 154.945 105.125C155.546 104.685 156.242 103.957 156.337 102.982C156.514 101.224 156.514 98.7656 156.514 98.7656C156.514 98.7656 160.812 101.265 161.481 101.265C162.149 101.265 159.694 108.146 162.409 111.319C163.446 112.514 162.19 113.228 160.253 113.654C157.674 113.269 156.514 112.171 156.514 112.171V112.157Z"
        fill="#F7B8AF"
      />
      <path
        d="M155.903 100.496C155.903 100.496 155.766 99.3836 156.503 99.4523C157.24 99.5209 157.294 101.65 157.103 102.611C156.912 103.573 156.203 103.998 156.066 102.515C155.943 101.032 155.903 100.482 155.903 100.482V100.496Z"
        fill="#F8C2BD"
      />
      <path
        d="M158.044 86.6655C161.946 86.1711 165.071 87.0226 167.404 89.2202C169.751 91.4177 171.32 97.1038 168.673 99.7683C168.236 101.21 167.65 102.556 167.254 103.765C165.153 104.754 162.328 104.85 160.65 104.438C158.726 103.971 159.299 101.375 157.867 99.9194C156.434 98.4635 155.097 99.9194 155.097 99.9194C155.097 99.9194 154.769 97.9279 154.701 96.9115C154.619 95.8951 154.114 95.6067 154.046 94.5766C153.964 93.5603 154.292 92.5164 153.869 91.8022C153.746 91.5962 153.705 91.3765 153.691 91.1842C153.691 91.1842 153.228 90.9782 153.159 90.058C153.091 89.1377 154.128 87.1737 158.03 86.693L158.044 86.6655Z"
        fill="#13130A"
      />
      <g opacity="0.3">
        <path
          d="M155.11 99.8916C155.11 99.8916 154.783 97.9001 154.715 96.8837C154.701 96.6365 154.646 96.4305 154.592 96.252C155.738 97.1996 158.276 99.1499 160.541 99.9465C162.997 100.812 166.121 100.455 168.673 99.768C168.236 101.21 167.649 102.556 167.254 103.765C165.152 104.754 162.328 104.85 160.65 104.438C158.726 103.971 159.299 101.375 157.866 99.9191C156.434 98.4632 155.097 99.9191 155.097 99.9191L155.11 99.8916Z"
          fill="#483089"
        />
      </g>
      <path
        d="M168.536 107.377L167.799 106.1C167.799 106.1 165.807 106.663 163.201 107.446C159.244 108.627 155.465 111.415 155.465 111.415C155.465 111.415 167.431 108.27 168.55 107.391L168.536 107.377Z"
        fill="white"
      />
      <path
        d="M147.182 146.631C147.81 142.964 148.915 138.445 148.724 133.913C148.519 129.381 148.383 120.7 149.352 118.956C149.788 118.187 148.779 118.311 149.87 117.171C151.221 115.756 154.646 113.119 154.646 113.119L168.563 109.26L169.518 108.889L175.726 109.534C175.726 109.534 176.613 116.099 176.081 119.341C175.549 122.582 173.024 129.271 171.824 131.716C170.623 134.147 170.282 139.915 170.964 142.58C171.769 145.725 173.925 154.721 173.925 154.721C173.925 154.721 172.397 157.688 167.676 159.885L165.97 148.636L166.775 160.27C165.657 160.723 164.374 161.135 162.928 161.451L161.727 161.629C158.493 162.426 149.529 162.742 144.631 158.539C144.631 158.539 146.582 150.243 147.196 146.631H147.182Z"
        fill="#353535"
      />
      <path
        d="M155.465 111.388C155.465 111.388 162.069 109.149 164.088 108.503C166.408 107.762 168.536 106.924 168.536 106.924L170.174 108.957C170.174 108.957 170.46 111.374 166.421 112.706C162.396 114.052 154.633 113.104 154.633 113.104L155.451 111.374L155.465 111.388Z"
        fill="#353535"
      />
      <g opacity="0.5">
        <path
          d="M144.631 158.539C144.631 158.539 146.582 150.243 147.196 146.631C147.824 142.964 148.929 138.445 148.738 133.913C148.615 131.221 148.519 127.087 148.67 123.79L156.351 121.785C156.351 121.785 157.156 127.499 154.7 131.001C151.699 135.286 150.17 142.208 150.034 144.887C149.911 147.222 146.732 155.146 147.1 160.146C146.2 159.706 145.368 159.171 144.631 158.539Z"
          fill="#B5BBC7"
        />
      </g>
      <path
        d="M127.385 114.56C127.385 114.56 125.038 112.349 123.947 111.552C122.842 110.755 121.409 109.011 121.382 108.627C121.354 108.242 122.064 107.775 122.064 107.775C122.064 107.775 121.436 106.869 121.586 106.429C121.736 105.99 122.842 105.536 122.842 105.536C122.842 105.536 122.541 104.836 122.691 104.479C122.842 104.108 123.988 103.49 124.029 103.49C124.07 103.49 124.274 103.311 124.274 103.311C124.274 103.311 123.715 101.608 123.606 101.114C123.483 100.606 124.452 99.7816 125.161 101.059C125.884 102.336 126.635 105.138 126.771 105.413C126.921 105.687 127.576 106.58 127.958 106.896C128.34 107.212 128.995 107.267 129.172 106.965C129.35 106.663 129.418 105.907 129.172 105.399C128.927 104.891 128.681 104.218 128.804 103.71C128.927 103.201 129.732 102.941 130.114 103.504C130.496 104.067 130.701 105.111 130.96 105.715C131.205 106.319 131.356 107.267 131.178 108.503C131.001 109.753 130.209 111.126 130.278 111.552C130.346 111.978 130.496 113.187 130.496 113.187L127.399 114.546L127.385 114.56Z"
        fill="#F8C2BD"
      />
      <path
        d="M122.064 107.774C122.064 107.774 121.436 106.868 121.586 106.428C121.736 105.989 122.842 105.536 122.842 105.536C122.842 105.536 122.541 104.835 122.691 104.478C122.842 104.107 123.988 103.489 124.029 103.489C124.07 103.489 124.274 103.311 124.274 103.311C124.274 103.311 124.752 105.069 124.847 105.577C124.943 106.071 124.956 106.332 124.847 106.428C124.724 106.538 124.042 106.895 123.879 107.335C123.715 107.788 123.824 107.678 123.401 108.076C122.964 108.475 122.487 108.859 122.664 109.395C122.787 109.766 123.033 110.37 123.033 110.768C122.187 109.931 121.395 108.914 121.382 108.64C121.354 108.255 122.064 107.788 122.064 107.788V107.774Z"
        fill="#F7B8AF"
      />
      <path
        d="M130.891 112.033L130.264 111.236C130.264 111.236 126.962 112.308 126.484 115.728L127.644 117.183L130.891 112.047V112.033Z"
        fill="white"
      />
      <path
        d="M155.261 117.91C155.261 117.91 153.597 115.191 150.213 117.91C146.829 120.629 140.907 124.489 140.907 124.489L131.22 111.949C131.22 111.949 127.645 114.463 127.754 118.569C127.754 118.569 135.832 130.45 137.319 132.304C138.806 134.158 141.017 133.897 141.726 133.897C142.436 133.897 151.359 129.818 153.037 128.472C155.084 126.81 157.922 122.539 155.261 117.896V117.91Z"
        fill="#353535"
      />
      <path
        d="M188.458 118.405L187.53 117.815C187.257 117.609 186.821 117.636 186.261 117.966L162.97 131.686C161.879 132.318 160.76 133.857 160.487 135.093L153.638 166.517C153.228 168.385 151.55 169.127 149.913 168.165L149.34 169.168C149.981 169.539 150.677 169.745 151.346 169.745C151.864 169.745 152.342 169.635 152.765 169.429C152.833 169.402 152.901 169.36 152.969 169.319L155.862 167.63L178.484 154.5C179.425 154.019 181.499 152.439 181.759 151.231L182.25 148.965C182.291 148.841 182.332 148.717 182.359 148.594L188.731 119.71C188.881 119.051 188.758 118.611 188.444 118.419L188.458 118.405Z"
        fill="white"
      />
      <g opacity="0.3">
        <path
          d="M177.283 123.254L162.97 131.687C161.879 132.319 160.76 133.857 160.487 135.093L153.638 166.518C153.228 168.386 151.55 169.127 149.913 168.166L149.34 169.169C149.981 169.539 150.677 169.745 151.346 169.745C153.024 169.745 154.361 168.578 154.757 166.765L161.279 137.552L161.674 135.78C161.947 134.544 163.066 133.005 164.157 132.374L178.143 124.284L177.283 123.254Z"
          fill="#3E79BD"
        />
      </g>
      <g opacity="0.2">
        <path
          d="M188.69 118.666C188.226 118.625 187.639 118.79 187.134 119.078L164.157 132.374C163.066 133.005 161.947 134.544 161.674 135.78L161.278 137.551L154.756 166.765C154.511 167.864 153.924 168.729 153.105 169.237L155.862 167.63L178.484 154.5C179.425 154.019 181.499 152.44 181.758 151.231L182.25 148.965C182.29 148.841 182.331 148.718 182.359 148.594L188.731 119.71C188.826 119.271 188.799 118.914 188.676 118.68L188.69 118.666Z"
          fill="#4A85C5"
        />
      </g>
      <mask
        id="mask7_1563_101126"
        maskUnits="userSpaceOnUse"
        x="111"
        y="29"
        width="23"
        height="29"
      >
        <path
          d="M131.23 29.9518L113.869 39.9626C112.801 40.5847 111.939 42.0741 111.939 43.2995V55.1013C111.939 56.3267 112.801 56.8169 113.869 56.2136L116.977 54.4226L116.94 57.8915L119.88 52.4808L131.23 46.2217C132.298 45.5995 133.159 44.1102 133.159 42.8847V31.0829C133.159 29.8575 132.298 29.3673 131.23 29.9706V29.9518Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask7_1563_101126)">
        <path
          d="M133.161 30.1011L132.168 29.3281H132.786L133.161 29.6298V30.1011Z"
          fill="url(#paint187_linear_1563_101126)"
        />
        <path
          d="M133.16 30.5913L131.568 29.3281H132.168L133.16 30.1011V30.5913Z"
          fill="url(#paint188_linear_1563_101126)"
        />
        <path
          d="M133.159 31.0626L130.949 29.3281H131.567L133.159 30.5913V31.0626Z"
          fill="url(#paint189_linear_1563_101126)"
        />
        <path
          d="M133.161 31.5339L130.352 29.3281H130.951L133.161 31.0626V31.5339Z"
          fill="url(#paint190_linear_1563_101126)"
        />
        <path
          d="M133.16 32.0241L129.732 29.3281H130.35L133.16 31.5339V32.0241Z"
          fill="url(#paint191_linear_1563_101126)"
        />
        <path
          d="M133.161 32.4954L129.115 29.3281H129.733L133.161 32.0241V32.4954Z"
          fill="url(#paint192_linear_1563_101126)"
        />
        <path
          d="M133.16 32.9667L128.516 29.3281H129.115L133.16 32.4954V32.9667Z"
          fill="url(#paint193_linear_1563_101126)"
        />
        <path
          d="M133.159 33.4569L127.896 29.3281H128.515L133.159 32.9667V33.4569Z"
          fill="url(#paint194_linear_1563_101126)"
        />
        <path
          d="M133.161 33.9282L127.299 29.3281H127.898L133.161 33.4569V33.9282Z"
          fill="url(#paint195_linear_1563_101126)"
        />
        <path
          d="M133.16 34.3995L126.68 29.3281H127.298L133.16 33.9282V34.3995Z"
          fill="url(#paint196_linear_1563_101126)"
        />
        <path
          d="M133.16 34.8897L126.08 29.3281H126.679L133.16 34.3995V34.8897Z"
          fill="url(#paint197_linear_1563_101126)"
        />
        <path
          d="M133.16 35.361L125.463 29.3281H126.081L133.16 34.8897V35.361Z"
          fill="url(#paint198_linear_1563_101126)"
        />
        <path
          d="M133.16 35.8512L124.863 29.3281H125.463L133.16 35.361V35.8512Z"
          fill="url(#paint199_linear_1563_101126)"
        />
        <path
          d="M133.159 36.3225L124.244 29.3281H124.862L133.159 35.8512V36.3225Z"
          fill="url(#paint200_linear_1563_101126)"
        />
        <path
          d="M133.161 36.7938L123.646 29.3281H124.246L133.161 36.3225V36.7938Z"
          fill="url(#paint201_linear_1563_101126)"
        />
        <path
          d="M133.16 37.284L123.027 29.3281H123.645L133.16 36.7938V37.284Z"
          fill="url(#paint202_linear_1563_101126)"
        />
        <path
          d="M133.159 37.7553L122.428 29.3281H123.027L133.159 37.284V37.7553Z"
          fill="url(#paint203_linear_1563_101126)"
        />
        <path
          d="M133.16 38.2266L121.811 29.3281H122.429L133.16 37.7553V38.2266Z"
          fill="url(#paint204_linear_1563_101126)"
        />
        <path
          d="M133.16 38.7168L121.268 29.3847L121.324 29.3281H121.811L133.16 38.2266V38.7168Z"
          fill="url(#paint205_linear_1563_101126)"
        />
        <path
          d="M133.16 39.1882L121.043 29.6864L121.268 29.3848L133.16 38.7169V39.1882Z"
          fill="url(#paint206_linear_1563_101126)"
        />
        <path
          d="M133.159 39.6586L120.816 29.9872L121.041 29.6855L133.159 39.1873V39.6586Z"
          fill="url(#paint207_linear_1563_101126)"
        />
        <path
          d="M133.16 40.1499L120.574 30.2711L120.818 29.9883L133.16 39.6597V40.1499Z"
          fill="url(#paint208_linear_1563_101126)"
        />
        <path
          d="M133.16 40.6197L120.35 30.5712L120.574 30.2695L133.16 40.1484V40.6197Z"
          fill="url(#paint209_linear_1563_101126)"
        />
        <path
          d="M133.16 41.11L120.125 30.8729L120.35 30.5713L133.16 40.6198V41.11Z"
          fill="url(#paint210_linear_1563_101126)"
        />
        <path
          d="M133.16 41.5814L119.881 31.1747L120.124 30.873L133.16 41.1101V41.5814Z"
          fill="url(#paint211_linear_1563_101126)"
        />
        <path
          d="M133.16 42.0538L119.656 31.4586L119.881 31.1758L133.16 41.5825V42.0538Z"
          fill="url(#paint212_linear_1563_101126)"
        />
        <path
          d="M133.16 42.5444L119.432 31.7606L119.656 31.459L133.16 42.0542V42.5444Z"
          fill="url(#paint213_linear_1563_101126)"
        />
        <path
          d="M133.159 43.0148L119.188 32.0614L119.431 31.7598L133.159 42.5435V43.0148Z"
          fill="url(#paint214_linear_1563_101126)"
        />
        <path
          d="M133.159 43.4873L118.963 32.3641L119.188 32.0625L133.159 43.0159V43.4873Z"
          fill="url(#paint215_linear_1563_101126)"
        />
        <path
          d="M133.159 43.9766L118.738 32.6461L118.963 32.3633L133.159 43.4864V43.9766Z"
          fill="url(#paint216_linear_1563_101126)"
        />
        <path
          d="M133.161 44.4483L118.496 32.9481L118.74 32.6465L133.161 43.977V44.4483Z"
          fill="url(#paint217_linear_1563_101126)"
        />
        <path
          d="M133.159 44.7491L133.065 44.8622L118.27 33.2489L118.494 32.9473L133.159 44.4474V44.7491Z"
          fill="url(#paint218_linear_1563_101126)"
        />
        <path
          d="M118.272 33.25L118.047 33.5516L132.843 45.1649L133.067 44.8633L118.272 33.25Z"
          fill="url(#paint219_linear_1563_101126)"
        />
        <path
          d="M118.046 33.5508L117.803 33.8336L132.617 45.4469L132.842 45.1641L118.046 33.5508Z"
          fill="url(#paint220_linear_1563_101126)"
        />
        <path
          d="M117.803 33.834L117.578 34.1356L132.374 45.7489L132.617 45.4473L117.803 33.834Z"
          fill="url(#paint221_linear_1563_101126)"
        />
        <path
          d="M117.578 34.1348L117.354 34.4364L132.149 46.0497L132.374 45.748L117.578 34.1348Z"
          fill="url(#paint222_linear_1563_101126)"
        />
        <path
          d="M117.353 34.4375L117.109 34.7391L131.924 46.3524L132.149 46.0508L117.353 34.4375Z"
          fill="url(#paint223_linear_1563_101126)"
        />
        <path
          d="M117.11 34.7383L116.885 35.0211L131.68 46.6344L131.924 46.3516L117.11 34.7383Z"
          fill="url(#paint224_linear_1563_101126)"
        />
        <path
          d="M116.885 35.0225L116.66 35.3241L131.456 46.9374L131.681 46.6357L116.885 35.0225Z"
          fill="url(#paint225_linear_1563_101126)"
        />
        <path
          d="M116.659 35.3232L116.416 35.6249L131.23 47.2382L131.455 46.9365L116.659 35.3232Z"
          fill="url(#paint226_linear_1563_101126)"
        />
        <path
          d="M116.416 35.625L116.191 35.9266L130.987 47.5399L131.231 47.2383L116.416 35.625Z"
          fill="url(#paint227_linear_1563_101126)"
        />
        <path
          d="M116.192 35.9277L115.967 36.2105L130.762 47.8238L130.987 47.541L116.192 35.9277Z"
          fill="url(#paint228_linear_1563_101126)"
        />
        <path
          d="M115.966 36.209L115.723 36.5106L130.537 48.1239L130.762 47.8223L115.966 36.209Z"
          fill="url(#paint229_linear_1563_101126)"
        />
        <path
          d="M115.723 36.5107L115.498 36.8124L130.294 48.4257L130.537 48.124L115.723 36.5107Z"
          fill="url(#paint230_linear_1563_101126)"
        />
        <path
          d="M115.498 36.8125L115.273 37.1141L130.069 48.7274L130.294 48.4258L115.498 36.8125Z"
          fill="url(#paint231_linear_1563_101126)"
        />
        <path
          d="M115.275 37.1143L115.031 37.3971L129.846 49.0103L130.07 48.7275L115.275 37.1143Z"
          fill="url(#paint232_linear_1563_101126)"
        />
        <path
          d="M115.029 37.3965L114.805 37.6981L129.6 49.3114L129.844 49.0098L115.029 37.3965Z"
          fill="url(#paint233_linear_1563_101126)"
        />
        <path
          d="M114.805 37.6982L114.58 37.9999L129.376 49.6132L129.601 49.3115L114.805 37.6982Z"
          fill="url(#paint234_linear_1563_101126)"
        />
        <path
          d="M114.581 38L114.338 38.2828L129.152 49.9149L129.377 49.6133L114.581 38Z"
          fill="url(#paint235_linear_1563_101126)"
        />
        <path
          d="M114.336 38.2832L114.111 38.5848L128.907 50.1981L129.15 49.9153L114.336 38.2832Z"
          fill="url(#paint236_linear_1563_101126)"
        />
        <path
          d="M114.113 38.585L113.889 38.8866L128.684 50.4999L128.909 50.1982L114.113 38.585Z"
          fill="url(#paint237_linear_1563_101126)"
        />
        <path
          d="M113.888 38.8867L113.645 39.1884L128.459 50.8016L128.684 50.5L113.888 38.8867Z"
          fill="url(#paint238_linear_1563_101126)"
        />
        <path
          d="M113.645 39.1875L113.42 39.4703L128.216 51.1024L128.459 50.8008L113.645 39.1875Z"
          fill="url(#paint239_linear_1563_101126)"
        />
        <path
          d="M113.42 39.4707L113.195 39.7723L127.991 51.3856L128.216 51.1028L113.42 39.4707Z"
          fill="url(#paint240_linear_1563_101126)"
        />
        <path
          d="M113.195 39.7715L112.951 40.0731L127.766 51.6864L127.99 51.3848L113.195 39.7715Z"
          fill="url(#paint241_linear_1563_101126)"
        />
        <path
          d="M112.951 40.0742L112.727 40.3759L127.522 51.9891L127.766 51.6875L112.951 40.0742Z"
          fill="url(#paint242_linear_1563_101126)"
        />
        <path
          d="M112.727 40.375L112.502 40.6578L127.298 52.2899L127.522 51.9883L112.727 40.375Z"
          fill="url(#paint243_linear_1563_101126)"
        />
        <path
          d="M112.501 40.6582L112.258 40.9598L127.072 52.5731L127.297 52.2903L112.501 40.6582Z"
          fill="url(#paint244_linear_1563_101126)"
        />
        <path
          d="M112.26 40.96L112.035 41.2616L126.831 52.8749L127.074 52.5733L112.26 40.96Z"
          fill="url(#paint245_linear_1563_101126)"
        />
        <path
          d="M126.829 52.875L126.604 53.1766L111.939 41.6576V41.3748L112.033 41.2617L126.829 52.875Z"
          fill="url(#paint246_linear_1563_101126)"
        />
        <path
          d="M126.604 53.1772L126.379 53.4789L111.939 42.1484V41.6582L126.604 53.1772Z"
          fill="url(#paint247_linear_1563_101126)"
        />
        <path
          d="M126.379 53.4789L126.136 53.7617L111.939 42.6198V42.1484L126.379 53.4789Z"
          fill="url(#paint248_linear_1563_101126)"
        />
        <path
          d="M126.136 53.7611L125.911 54.0627L111.939 43.0905V42.6191L126.136 53.7611Z"
          fill="url(#paint249_linear_1563_101126)"
        />
        <path
          d="M125.911 54.0631L125.686 54.3648L111.939 43.581V43.0908L125.911 54.0631Z"
          fill="url(#paint250_linear_1563_101126)"
        />
        <path
          d="M125.686 54.3648L125.443 54.6665L111.939 44.0524V43.5811L125.686 54.3648Z"
          fill="url(#paint251_linear_1563_101126)"
        />
        <path
          d="M125.443 54.6668L125.218 54.9496L111.939 44.5429V44.0527L125.443 54.6668Z"
          fill="url(#paint252_linear_1563_101126)"
        />
        <path
          d="M125.218 54.9487L124.993 55.2503L111.939 45.0133V44.542L125.218 54.9487Z"
          fill="url(#paint253_linear_1563_101126)"
        />
        <path
          d="M124.993 55.2517L124.75 55.5533L111.939 45.486V45.0146L124.993 55.2517Z"
          fill="url(#paint254_linear_1563_101126)"
        />
        <path
          d="M124.75 55.5527L124.525 55.8544L111.939 45.9755V45.4854L124.75 55.5527Z"
          fill="url(#paint255_linear_1563_101126)"
        />
        <path
          d="M124.525 55.8525L124.3 56.1353L111.939 46.445V45.9736L124.525 55.8525Z"
          fill="url(#paint256_linear_1563_101126)"
        />
        <path
          d="M124.3 56.1376L124.057 56.4392L111.939 46.9186V46.4473L124.3 56.1376Z"
          fill="url(#paint257_linear_1563_101126)"
        />
        <path
          d="M124.057 56.4386L123.832 56.7402L111.939 47.4081V46.918L124.057 56.4386Z"
          fill="url(#paint258_linear_1563_101126)"
        />
        <path
          d="M123.832 56.7393L123.607 57.041L111.939 47.8785V47.4072L123.832 56.7393Z"
          fill="url(#paint259_linear_1563_101126)"
        />
        <path
          d="M123.607 57.0413L123.364 57.3241L111.939 48.3502V47.8789L123.607 57.0413Z"
          fill="url(#paint260_linear_1563_101126)"
        />
        <path
          d="M123.364 57.3245L123.139 57.6261L111.939 48.8408V48.3506L123.364 57.3245Z"
          fill="url(#paint261_linear_1563_101126)"
        />
        <path
          d="M123.139 57.6262L122.952 57.8713H122.84L111.939 49.3121V48.8408L123.139 57.6262Z"
          fill="url(#paint262_linear_1563_101126)"
        />
        <path
          d="M122.222 57.8716L111.939 49.8027V49.3125L122.84 57.8716H122.222Z"
          fill="url(#paint263_linear_1563_101126)"
        />
        <path
          d="M121.622 57.8717L111.939 50.2741V49.8027L122.222 57.8717H121.622Z"
          fill="url(#paint264_linear_1563_101126)"
        />
        <path
          d="M121.004 57.8711L111.939 50.7448V50.2734L121.622 57.8711H121.004Z"
          fill="url(#paint265_linear_1563_101126)"
        />
        <path
          d="M120.405 57.8714L111.939 51.2353V50.7451L121.004 57.8714H120.405Z"
          fill="url(#paint266_linear_1563_101126)"
        />
        <path
          d="M119.787 57.8705L111.939 51.7057V51.2344L120.405 57.8705H119.787Z"
          fill="url(#paint267_linear_1563_101126)"
        />
        <path
          d="M119.169 57.8709L111.939 52.1774V51.7061L119.787 57.8709H119.169Z"
          fill="url(#paint268_linear_1563_101126)"
        />
        <path
          d="M118.569 57.8713L111.939 52.6679V52.1777L119.169 57.8713H118.569Z"
          fill="url(#paint269_linear_1563_101126)"
        />
        <path
          d="M117.951 57.8713L111.939 53.1393V52.668L118.569 57.8713H117.951Z"
          fill="url(#paint270_linear_1563_101126)"
        />
        <path
          d="M117.352 57.8707L111.939 53.61V53.1387L117.951 57.8707H117.352Z"
          fill="url(#paint271_linear_1563_101126)"
        />
        <path
          d="M116.734 57.8711L111.939 54.1005V53.6104L117.352 57.8711H116.734Z"
          fill="url(#paint272_linear_1563_101126)"
        />
        <path
          d="M116.135 57.8721L111.939 54.5729V54.1016L116.734 57.8721H116.135Z"
          fill="url(#paint273_linear_1563_101126)"
        />
        <path
          d="M115.517 57.8705L111.939 55.0615V54.5713L116.135 57.8705H115.517Z"
          fill="url(#paint274_linear_1563_101126)"
        />
        <path
          d="M114.917 57.8725L111.939 55.5348V55.0635L115.517 57.8725H114.917Z"
          fill="url(#paint275_linear_1563_101126)"
        />
        <path
          d="M114.299 57.8709L111.939 56.0045V55.5332L114.917 57.8709H114.299Z"
          fill="url(#paint276_linear_1563_101126)"
        />
        <path
          d="M113.7 57.8713L111.939 56.4951V56.0049L114.299 57.8713H113.7Z"
          fill="url(#paint277_linear_1563_101126)"
        />
        <path
          d="M113.082 57.8714L111.939 56.9664V56.4951L113.7 57.8714H113.082Z"
          fill="url(#paint278_linear_1563_101126)"
        />
        <path
          d="M112.483 57.8717L111.939 57.4381V56.9668L113.082 57.8717H112.483Z"
          fill="url(#paint279_linear_1563_101126)"
        />
        <path
          d="M111.939 57.4375L112.483 57.8711H111.939V57.4375Z"
          fill="url(#paint280_linear_1563_101126)"
        />
      </g>
      <g>
        <path
          d="M113.869 39.9621L131.23 29.9513C131.867 29.5742 132.429 29.6119 132.785 29.9701C132.447 29.8193 131.998 29.857 131.511 30.1398L114.149 40.1506C113.082 40.7727 112.22 42.2621 112.22 43.4875V55.2893C112.22 55.7795 112.37 56.1377 112.595 56.3828C112.202 56.2131 111.939 55.7607 111.939 55.1008V43.299C111.939 42.0736 112.801 40.5842 113.869 39.9621Z"
          fill="#2D2623"
        />
      </g>
      <g>
        <path
          d="M126.324 39.9425C125.762 40.9229 125.762 41.9786 126.324 42.2991C126.886 42.6196 127.803 42.0917 128.365 41.1114C128.927 40.1311 128.927 39.0753 128.365 38.7548C127.803 38.4343 126.886 38.9622 126.324 39.9425Z"
          fill="#BEBDC2"
        />
      </g>
      <g>
        <path
          d="M121.623 42.6388C121.061 43.6192 121.061 44.6749 121.623 44.9954C122.184 45.3159 123.102 44.788 123.664 43.8077C124.226 42.8273 124.226 41.7716 123.664 41.4511C123.102 41.1306 122.184 41.6585 121.623 42.6388Z"
          fill="#BEBDC2"
        />
      </g>
      <g>
        <path
          d="M116.923 45.3537C116.361 46.334 116.361 47.3898 116.923 47.7103C117.485 48.0307 118.403 47.5029 118.965 46.5225C119.527 45.5422 119.527 44.4864 118.965 44.1659C118.403 43.8454 117.485 44.3733 116.923 45.3537Z"
          fill="#BEBDC2"
        />
      </g>
      <path
        d="M126.099 39.8498C125.537 40.8301 125.537 41.8858 126.099 42.2063C126.661 42.5268 127.579 41.999 128.141 41.0186C128.702 40.0383 128.702 38.9825 128.141 38.662C127.579 38.3415 126.661 38.8694 126.099 39.8498Z"
        fill="white"
      />
      <path
        d="M121.398 42.5451C120.836 43.5254 120.836 44.5812 121.398 44.9017C121.96 45.2221 122.878 44.6943 123.439 43.7139C124.001 42.7336 124.001 41.6778 123.439 41.3573C122.878 41.0368 121.96 41.5647 121.398 42.5451Z"
        fill="white"
      />
      <path
        d="M116.699 45.2599C116.137 46.2403 116.137 47.296 116.699 47.6165C117.261 47.937 118.178 47.4091 118.74 46.4288C119.302 45.4484 119.302 44.3927 118.74 44.0722C118.178 43.7517 117.261 44.2796 116.699 45.2599Z"
        fill="white"
      />
      <rect
        y="42.6426"
        width="66.4309"
        height="62.5491"
        fill="url(#pattern0)"
      />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_1563_101126"
            transform="matrix(0.00375126 0 0 0.00398406 -0.000793333 0)"
          />
        </pattern>
        <linearGradient
          id="paint0_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="92.2793"
          y2="69.8273"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="92.7442"
          y2="70.1881"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="93.201"
          y2="70.551"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="93.6659"
          y2="70.9118"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="94.1252"
          y2="71.2511"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="94.59"
          y2="71.6119"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="95.0468"
          y2="71.9748"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="95.5117"
          y2="72.3356"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="95.971"
          y2="72.675"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="96.4359"
          y2="73.0358"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="96.8927"
          y2="73.3987"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="97.3575"
          y2="73.7595"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="97.8224"
          y2="74.1203"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="98.2817"
          y2="74.4596"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="98.7385"
          y2="74.8225"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="99.2034"
          y2="75.1834"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="99.6682"
          y2="75.5442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="100.128"
          y2="75.8835"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="100.584"
          y2="76.2464"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="101.049"
          y2="76.6072"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="101.514"
          y2="76.968"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="101.971"
          y2="77.3309"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="102.43"
          y2="77.6702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="102.895"
          y2="78.0311"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="103.36"
          y2="78.3919"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="103.817"
          y2="78.7548"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="104.276"
          y2="79.0941"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="104.741"
          y2="79.4549"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="105.206"
          y2="79.8157"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="105.663"
          y2="80.1786"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="106.127"
          y2="80.5394"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="106.587"
          y2="80.8788"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="107.052"
          y2="81.2396"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="107.508"
          y2="81.6025"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="107.973"
          y2="81.9633"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint35_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="108.432"
          y2="82.3026"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint36_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="108.897"
          y2="82.6634"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint37_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="109.354"
          y2="83.0263"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint38_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="109.819"
          y2="83.3872"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint39_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="110.284"
          y2="83.748"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint40_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="110.743"
          y2="84.0873"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint41_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="111.2"
          y2="84.4502"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint42_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="111.665"
          y2="84.811"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="112.13"
          y2="85.1718"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="112.581"
          y2="85.5132"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="113.046"
          y2="85.874"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint46_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="113.511"
          y2="86.2348"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint47_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="113.976"
          y2="86.5957"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint48_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="114.432"
          y2="86.9586"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint49_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="114.892"
          y2="87.2979"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint50_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="115.357"
          y2="87.6587"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint51_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="115.821"
          y2="88.0195"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint52_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="116.278"
          y2="88.3824"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint53_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="116.737"
          y2="88.7218"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint54_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="117.202"
          y2="89.0826"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint55_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="117.667"
          y2="89.4434"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint56_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="118.124"
          y2="89.8063"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint57_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="118.589"
          y2="90.1671"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint58_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="119.048"
          y2="90.5064"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint59_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="119.513"
          y2="90.8672"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint60_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="119.97"
          y2="91.2301"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint61_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="120.435"
          y2="91.5909"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint62_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="120.894"
          y2="91.9303"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint63_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="121.359"
          y2="92.2911"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint64_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="121.816"
          y2="92.654"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint65_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="122.281"
          y2="93.0148"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint66_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="122.745"
          y2="93.3756"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint67_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="123.197"
          y2="93.717"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint68_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="123.661"
          y2="94.0778"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint69_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="124.126"
          y2="94.4386"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint70_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="124.591"
          y2="94.7995"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint71_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="125.042"
          y2="95.1409"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint72_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="125.507"
          y2="95.5017"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint73_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="125.972"
          y2="95.8625"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint74_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="126.437"
          y2="96.2233"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint75_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="126.888"
          y2="96.5647"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint76_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="127.353"
          y2="96.9255"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint77_linear_1563_101126"
          x1="83.5449"
          y1="63.084"
          x2="127.786"
          y2="97.2948"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint78_linear_1563_101126"
          x1="83.5723"
          y1="63.084"
          x2="127.917"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint79_linear_1563_101126"
          x1="83.8594"
          y1="63.084"
          x2="128.204"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint80_linear_1563_101126"
          x1="84.1465"
          y1="63.084"
          x2="128.486"
          y2="97.6806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint81_linear_1563_101126"
          x1="84.418"
          y1="63.084"
          x2="128.763"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint82_linear_1563_101126"
          x1="84.7051"
          y1="63.084"
          x2="129.05"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint83_linear_1563_101126"
          x1="84.9922"
          y1="63.084"
          x2="129.337"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint84_linear_1563_101126"
          x1="85.2773"
          y1="63.084"
          x2="129.617"
          y2="97.6806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint85_linear_1563_101126"
          x1="85.5508"
          y1="63.084"
          x2="129.895"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint86_linear_1563_101126"
          x1="85.8379"
          y1="63.084"
          x2="130.183"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint87_linear_1563_101126"
          x1="86.123"
          y1="63.084"
          x2="130.468"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint88_linear_1563_101126"
          x1="86.4102"
          y1="63.084"
          x2="130.755"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint89_linear_1563_101126"
          x1="86.6973"
          y1="63.084"
          x2="131.037"
          y2="97.6806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint90_linear_1563_101126"
          x1="86.9707"
          y1="63.084"
          x2="131.315"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint91_linear_1563_101126"
          x1="87.2559"
          y1="63.084"
          x2="131.601"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint92_linear_1563_101126"
          x1="87.543"
          y1="63.084"
          x2="131.888"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint93_linear_1563_101126"
          x1="87.8301"
          y1="63.084"
          x2="132.169"
          y2="97.6806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint94_linear_1563_101126"
          x1="88.1035"
          y1="63.084"
          x2="132.448"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint95_linear_1563_101126"
          x1="88.3887"
          y1="63.084"
          x2="132.733"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint96_linear_1563_101126"
          x1="88.6758"
          y1="63.084"
          x2="133.02"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint97_linear_1563_101126"
          x1="88.9609"
          y1="63.084"
          x2="133.306"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint98_linear_1563_101126"
          x1="89.248"
          y1="63.084"
          x2="133.587"
          y2="97.6806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint99_linear_1563_101126"
          x1="89.5215"
          y1="63.084"
          x2="133.866"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint100_linear_1563_101126"
          x1="89.8086"
          y1="63.084"
          x2="134.153"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint101_linear_1563_101126"
          x1="90.0938"
          y1="63.084"
          x2="134.438"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint102_linear_1563_101126"
          x1="90.3828"
          y1="63.084"
          x2="134.722"
          y2="97.6806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint103_linear_1563_101126"
          x1="90.6543"
          y1="63.084"
          x2="134.999"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint104_linear_1563_101126"
          x1="90.9414"
          y1="63.084"
          x2="135.286"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint105_linear_1563_101126"
          x1="91.2266"
          y1="63.084"
          x2="135.571"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint106_linear_1563_101126"
          x1="91.5137"
          y1="63.084"
          x2="135.858"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint107_linear_1563_101126"
          x1="91.7988"
          y1="63.084"
          x2="136.138"
          y2="97.6806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint108_linear_1563_101126"
          x1="92.0723"
          y1="63.084"
          x2="136.417"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint109_linear_1563_101126"
          x1="92.3594"
          y1="63.084"
          x2="136.704"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint110_linear_1563_101126"
          x1="92.6465"
          y1="63.084"
          x2="136.991"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint111_linear_1563_101126"
          x1="92.9316"
          y1="63.084"
          x2="137.271"
          y2="97.6806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint112_linear_1563_101126"
          x1="93.2051"
          y1="63.084"
          x2="137.55"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint113_linear_1563_101126"
          x1="93.4922"
          y1="63.084"
          x2="137.837"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint114_linear_1563_101126"
          x1="93.7793"
          y1="63.084"
          x2="138.124"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint115_linear_1563_101126"
          x1="94.0645"
          y1="63.084"
          x2="138.409"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint116_linear_1563_101126"
          x1="94.3379"
          y1="63.084"
          x2="138.683"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint117_linear_1563_101126"
          x1="94.625"
          y1="63.084"
          x2="138.97"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint118_linear_1563_101126"
          x1="94.9121"
          y1="63.084"
          x2="139.257"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint119_linear_1563_101126"
          x1="95.1973"
          y1="63.084"
          x2="139.542"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint120_linear_1563_101126"
          x1="95.4844"
          y1="63.084"
          x2="139.824"
          y2="97.6806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint121_linear_1563_101126"
          x1="95.7559"
          y1="63.084"
          x2="140.101"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint122_linear_1563_101126"
          x1="96.043"
          y1="63.084"
          x2="140.388"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint123_linear_1563_101126"
          x1="96.3301"
          y1="63.084"
          x2="140.675"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint124_linear_1563_101126"
          x1="96.6172"
          y1="63.084"
          x2="140.962"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint125_linear_1563_101126"
          x1="96.8887"
          y1="63.084"
          x2="141.233"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint126_linear_1563_101126"
          x1="97.1758"
          y1="63.084"
          x2="141.52"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint127_linear_1563_101126"
          x1="97.4629"
          y1="63.084"
          x2="141.808"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint128_linear_1563_101126"
          x1="97.748"
          y1="63.084"
          x2="142.093"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint129_linear_1563_101126"
          x1="98.0352"
          y1="63.084"
          x2="142.374"
          y2="97.6806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint130_linear_1563_101126"
          x1="98.3086"
          y1="63.084"
          x2="142.653"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint131_linear_1563_101126"
          x1="98.5938"
          y1="63.084"
          x2="142.938"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint132_linear_1563_101126"
          x1="98.8809"
          y1="63.084"
          x2="143.226"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint133_linear_1563_101126"
          x1="99.168"
          y1="63.084"
          x2="143.507"
          y2="97.6806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint134_linear_1563_101126"
          x1="99.4414"
          y1="63.084"
          x2="143.786"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint135_linear_1563_101126"
          x1="99.7266"
          y1="63.084"
          x2="144.071"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint136_linear_1563_101126"
          x1="100.014"
          y1="63.084"
          x2="144.358"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint137_linear_1563_101126"
          x1="100.299"
          y1="63.084"
          x2="144.643"
          y2="97.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint138_linear_1563_101126"
          x1="100.586"
          y1="63.084"
          x2="144.925"
          y2="97.6806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint139_linear_1563_101126"
          x1="100.859"
          y1="63.084"
          x2="145.199"
          y2="97.6806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint140_linear_1563_101126"
          x1="101.146"
          y1="63.125"
          x2="145.346"
          y2="97.2776"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint141_linear_1563_101126"
          x1="101.434"
          y1="63.7158"
          x2="145.168"
          y2="97.5076"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint142_linear_1563_101126"
          x1="101.719"
          y1="64.293"
          x2="144.997"
          y2="97.7219"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint143_linear_1563_101126"
          x1="101.992"
          y1="64.8828"
          x2="144.811"
          y2="97.9724"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint144_linear_1563_101126"
          x1="102.279"
          y1="65.4736"
          x2="144.633"
          y2="98.2024"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint145_linear_1563_101126"
          x1="102.564"
          y1="66.0645"
          x2="144.454"
          y2="98.4324"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint146_linear_1563_101126"
          x1="102.852"
          y1="66.6406"
          x2="144.284"
          y2="98.6457"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint147_linear_1563_101126"
          x1="103.139"
          y1="67.2314"
          x2="144.106"
          y2="98.8757"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint148_linear_1563_101126"
          x1="103.412"
          y1="67.8223"
          x2="143.92"
          y2="99.1272"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint149_linear_1563_101126"
          x1="103.697"
          y1="68.3994"
          x2="143.749"
          y2="99.3414"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint150_linear_1563_101126"
          x1="103.984"
          y1="68.9893"
          x2="143.571"
          y2="99.5705"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint151_linear_1563_101126"
          x1="104.27"
          y1="69.5801"
          x2="143.391"
          y2="99.8005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint152_linear_1563_101126"
          x1="104.545"
          y1="70.1709"
          x2="143.207"
          y2="100.052"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint153_linear_1563_101126"
          x1="104.83"
          y1="70.748"
          x2="143.036"
          y2="100.266"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint154_linear_1563_101126"
          x1="105.117"
          y1="71.3379"
          x2="142.858"
          y2="100.495"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint155_linear_1563_101126"
          x1="105.404"
          y1="71.9287"
          x2="142.68"
          y2="100.725"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint156_linear_1563_101126"
          x1="105.689"
          y1="72.5195"
          x2="142.5"
          y2="100.955"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint157_linear_1563_101126"
          x1="105.963"
          y1="73.0967"
          x2="142.323"
          y2="101.191"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint158_linear_1563_101126"
          x1="106.25"
          y1="73.6865"
          x2="142.145"
          y2="101.42"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint159_linear_1563_101126"
          x1="106.535"
          y1="74.2773"
          x2="141.965"
          y2="101.65"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint160_linear_1563_101126"
          x1="106.822"
          y1="74.8682"
          x2="141.787"
          y2="101.88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint161_linear_1563_101126"
          x1="107.096"
          y1="75.4443"
          x2="141.61"
          y2="102.115"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint162_linear_1563_101126"
          x1="107.383"
          y1="76.0352"
          x2="141.432"
          y2="102.345"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint163_linear_1563_101126"
          x1="107.668"
          y1="76.627"
          x2="141.252"
          y2="102.576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint164_linear_1563_101126"
          x1="107.955"
          y1="77.2168"
          x2="141.074"
          y2="102.805"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint165_linear_1563_101126"
          x1="108.24"
          y1="77.7939"
          x2="140.903"
          y2="103.019"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint166_linear_1563_101126"
          x1="108.514"
          y1="78.3848"
          x2="140.717"
          y2="103.271"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint167_linear_1563_101126"
          x1="108.801"
          y1="78.9746"
          x2="140.539"
          y2="103.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint168_linear_1563_101126"
          x1="109.088"
          y1="79.5654"
          x2="140.361"
          y2="103.73"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint169_linear_1563_101126"
          x1="109.373"
          y1="80.1426"
          x2="140.19"
          y2="103.944"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint170_linear_1563_101126"
          x1="109.646"
          y1="80.7324"
          x2="140.004"
          y2="104.194"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint171_linear_1563_101126"
          x1="109.934"
          y1="81.3232"
          x2="139.826"
          y2="104.424"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint172_linear_1563_101126"
          x1="110.221"
          y1="81.9004"
          x2="139.656"
          y2="104.639"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint173_linear_1563_101126"
          x1="110.506"
          y1="82.4902"
          x2="139.477"
          y2="104.868"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint174_linear_1563_101126"
          x1="110.777"
          y1="83.0811"
          x2="139.289"
          y2="105.119"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint175_linear_1563_101126"
          x1="111.066"
          y1="83.6709"
          x2="139.113"
          y2="105.348"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint176_linear_1563_101126"
          x1="111.354"
          y1="84.248"
          x2="138.943"
          y2="105.562"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint177_linear_1563_101126"
          x1="111.639"
          y1="84.8389"
          x2="138.764"
          y2="105.792"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint178_linear_1563_101126"
          x1="111.926"
          y1="85.4297"
          x2="138.586"
          y2="106.022"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint179_linear_1563_101126"
          x1="112.199"
          y1="86.0205"
          x2="138.4"
          y2="106.274"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint180_linear_1563_101126"
          x1="112.484"
          y1="86.5977"
          x2="138.228"
          y2="106.488"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint181_linear_1563_101126"
          x1="112.771"
          y1="87.1875"
          x2="138.051"
          y2="106.717"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint182_linear_1563_101126"
          x1="113.059"
          y1="87.7773"
          x2="137.873"
          y2="106.946"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint183_linear_1563_101126"
          x1="113.33"
          y1="88.3691"
          x2="137.685"
          y2="107.199"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint184_linear_1563_101126"
          x1="113.617"
          y1="88.9463"
          x2="137.515"
          y2="107.413"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint185_linear_1563_101126"
          x1="113.904"
          y1="89.5361"
          x2="137.338"
          y2="107.642"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint186_linear_1563_101126"
          x1="114.189"
          y1="90.127"
          x2="137.158"
          y2="107.872"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint187_linear_1563_101126"
          x1="132.168"
          y1="29.3281"
          x2="132.662"
          y2="30.3436"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint188_linear_1563_101126"
          x1="131.568"
          y1="29.3281"
          x2="132.385"
          y2="30.9756"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint189_linear_1563_101126"
          x1="130.949"
          y1="29.3281"
          x2="132.064"
          y2="31.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint190_linear_1563_101126"
          x1="130.352"
          y1="29.3281"
          x2="131.769"
          y2="32.2169"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint191_linear_1563_101126"
          x1="129.732"
          y1="29.3281"
          x2="131.467"
          y2="32.8563"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint192_linear_1563_101126"
          x1="129.115"
          y1="29.3281"
          x2="131.147"
          y2="33.4806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint193_linear_1563_101126"
          x1="128.516"
          y1="29.3281"
          x2="130.851"
          y2="34.0975"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint194_linear_1563_101126"
          x1="127.896"
          y1="29.3281"
          x2="130.549"
          y2="34.737"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint195_linear_1563_101126"
          x1="127.299"
          y1="29.3281"
          x2="130.255"
          y2="35.3538"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint196_linear_1563_101126"
          x1="126.68"
          y1="29.3281"
          x2="129.933"
          y2="35.9781"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint197_linear_1563_101126"
          x1="126.08"
          y1="29.3281"
          x2="129.656"
          y2="36.6101"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint198_linear_1563_101126"
          x1="125.463"
          y1="29.3281"
          x2="129.336"
          y2="37.2345"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint199_linear_1563_101126"
          x1="124.863"
          y1="29.3281"
          x2="129.059"
          y2="37.8664"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint200_linear_1563_101126"
          x1="124.244"
          y1="29.3281"
          x2="128.738"
          y2="38.4908"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint201_linear_1563_101126"
          x1="123.646"
          y1="29.3281"
          x2="128.443"
          y2="39.1077"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint202_linear_1563_101126"
          x1="123.027"
          y1="29.3281"
          x2="128.141"
          y2="39.7471"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint203_linear_1563_101126"
          x1="122.428"
          y1="29.3281"
          x2="127.845"
          y2="40.364"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint204_linear_1563_101126"
          x1="121.811"
          y1="29.3281"
          x2="127.525"
          y2="40.9883"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint205_linear_1563_101126"
          x1="121.268"
          y1="29.3281"
          x2="127.322"
          y2="41.5977"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint206_linear_1563_101126"
          x1="121.043"
          y1="29.3848"
          x2="127.459"
          y2="42.0716"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint207_linear_1563_101126"
          x1="120.816"
          y1="29.6855"
          x2="127.339"
          y2="42.5983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint208_linear_1563_101126"
          x1="120.574"
          y1="29.9883"
          x2="127.217"
          y2="43.1495"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint209_linear_1563_101126"
          x1="120.35"
          y1="30.2695"
          x2="127.118"
          y2="43.6712"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint210_linear_1563_101126"
          x1="120.125"
          y1="30.5713"
          x2="127.019"
          y2="44.2134"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint211_linear_1563_101126"
          x1="119.881"
          y1="30.873"
          x2="126.876"
          y2="44.7491"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint212_linear_1563_101126"
          x1="119.656"
          y1="31.1758"
          x2="126.757"
          y2="45.2777"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint213_linear_1563_101126"
          x1="119.432"
          y1="31.459"
          x2="126.678"
          y2="45.8159"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint214_linear_1563_101126"
          x1="119.188"
          y1="31.7598"
          x2="126.535"
          y2="46.3506"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint215_linear_1563_101126"
          x1="118.963"
          y1="32.0625"
          x2="126.416"
          y2="46.8792"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint216_linear_1563_101126"
          x1="118.738"
          y1="32.3633"
          x2="126.318"
          y2="47.4205"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint217_linear_1563_101126"
          x1="118.496"
          y1="32.6465"
          x2="126.196"
          y2="47.9521"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint218_linear_1563_101126"
          x1="118.27"
          y1="32.9473"
          x2="126.017"
          y2="48.4348"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint219_linear_1563_101126"
          x1="118.047"
          y1="33.25"
          x2="125.753"
          y2="48.7916"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint220_linear_1563_101126"
          x1="117.803"
          y1="33.5508"
          x2="125.484"
          y2="49.0851"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint221_linear_1563_101126"
          x1="117.578"
          y1="33.834"
          x2="125.279"
          y2="49.3833"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint222_linear_1563_101126"
          x1="117.354"
          y1="34.1348"
          x2="125.06"
          y2="49.6764"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint223_linear_1563_101126"
          x1="117.109"
          y1="34.4375"
          x2="124.81"
          y2="49.9868"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint224_linear_1563_101126"
          x1="116.885"
          y1="34.7383"
          x2="124.566"
          y2="50.2726"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint225_linear_1563_101126"
          x1="116.66"
          y1="35.0225"
          x2="124.366"
          y2="50.5641"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint226_linear_1563_101126"
          x1="116.416"
          y1="35.3232"
          x2="124.117"
          y2="50.8725"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint227_linear_1563_101126"
          x1="116.191"
          y1="35.625"
          x2="123.892"
          y2="51.1743"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint228_linear_1563_101126"
          x1="115.967"
          y1="35.9277"
          x2="123.654"
          y2="51.4545"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint229_linear_1563_101126"
          x1="115.723"
          y1="36.209"
          x2="123.423"
          y2="51.7583"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint230_linear_1563_101126"
          x1="115.498"
          y1="36.5107"
          x2="123.199"
          y2="52.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint231_linear_1563_101126"
          x1="115.273"
          y1="36.8125"
          x2="122.98"
          y2="52.3541"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint232_linear_1563_101126"
          x1="115.031"
          y1="37.1143"
          x2="122.712"
          y2="52.6486"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint233_linear_1563_101126"
          x1="114.805"
          y1="37.3965"
          x2="122.505"
          y2="52.9458"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint234_linear_1563_101126"
          x1="114.58"
          y1="37.6982"
          x2="122.286"
          y2="53.2399"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint235_linear_1563_101126"
          x1="114.338"
          y1="38"
          x2="122.038"
          y2="53.5493"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint236_linear_1563_101126"
          x1="114.111"
          y1="38.2832"
          x2="121.812"
          y2="53.8325"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint237_linear_1563_101126"
          x1="113.889"
          y1="38.585"
          x2="121.595"
          y2="54.1266"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint238_linear_1563_101126"
          x1="113.645"
          y1="38.8867"
          x2="121.345"
          y2="54.436"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint239_linear_1563_101126"
          x1="113.42"
          y1="39.1875"
          x2="121.12"
          y2="54.7368"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint240_linear_1563_101126"
          x1="113.195"
          y1="39.4707"
          x2="120.902"
          y2="55.0123"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint241_linear_1563_101126"
          x1="112.951"
          y1="39.7715"
          x2="120.652"
          y2="55.3208"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint242_linear_1563_101126"
          x1="112.727"
          y1="40.0742"
          x2="120.427"
          y2="55.6235"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint243_linear_1563_101126"
          x1="112.502"
          y1="40.375"
          x2="120.208"
          y2="55.9166"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint244_linear_1563_101126"
          x1="112.258"
          y1="40.6582"
          x2="119.958"
          y2="56.2075"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint245_linear_1563_101126"
          x1="112.035"
          y1="40.96"
          x2="119.736"
          y2="56.5092"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint246_linear_1563_101126"
          x1="111.939"
          y1="41.2617"
          x2="119.687"
          y2="56.7493"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint247_linear_1563_101126"
          x1="111.939"
          y1="41.6582"
          x2="119.659"
          y2="56.9784"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint248_linear_1563_101126"
          x1="111.939"
          y1="42.1484"
          x2="119.513"
          y2="57.2135"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint249_linear_1563_101126"
          x1="111.939"
          y1="42.6191"
          x2="119.413"
          y2="57.4504"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint250_linear_1563_101126"
          x1="111.939"
          y1="43.0908"
          x2="119.306"
          y2="57.6962"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint251_linear_1563_101126"
          x1="111.939"
          y1="43.5811"
          x2="119.18"
          y2="57.9459"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint252_linear_1563_101126"
          x1="111.939"
          y1="44.0527"
          x2="119.06"
          y2="58.1692"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint253_linear_1563_101126"
          x1="111.939"
          y1="44.542"
          x2="118.934"
          y2="58.418"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint254_linear_1563_101126"
          x1="111.939"
          y1="45.0146"
          x2="118.828"
          y2="58.6647"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint255_linear_1563_101126"
          x1="111.939"
          y1="45.4854"
          x2="118.727"
          y2="58.9015"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint256_linear_1563_101126"
          x1="111.939"
          y1="45.9736"
          x2="118.582"
          y2="59.1348"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint257_linear_1563_101126"
          x1="111.939"
          y1="46.4473"
          x2="118.475"
          y2="59.3825"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint258_linear_1563_101126"
          x1="111.939"
          y1="46.918"
          x2="118.375"
          y2="59.6192"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint259_linear_1563_101126"
          x1="111.939"
          y1="47.4072"
          x2="118.249"
          y2="59.868"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint260_linear_1563_101126"
          x1="111.939"
          y1="47.8789"
          x2="118.123"
          y2="60.0993"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint261_linear_1563_101126"
          x1="111.939"
          y1="48.3506"
          x2="118.023"
          y2="60.3369"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint262_linear_1563_101126"
          x1="111.939"
          y1="48.8408"
          x2="117.838"
          y2="60.5433"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint263_linear_1563_101126"
          x1="111.939"
          y1="49.3125"
          x2="117.441"
          y2="60.5214"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint264_linear_1563_101126"
          x1="111.939"
          y1="49.8027"
          x2="117.124"
          y2="60.3722"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint265_linear_1563_101126"
          x1="111.939"
          y1="50.2734"
          x2="116.821"
          y2="60.226"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint266_linear_1563_101126"
          x1="111.939"
          y1="50.7451"
          x2="116.524"
          y2="60.0733"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint267_linear_1563_101126"
          x1="111.939"
          y1="51.2344"
          x2="116.201"
          y2="59.9306"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint268_linear_1563_101126"
          x1="111.939"
          y1="51.7061"
          x2="115.903"
          y2="59.778"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint269_linear_1563_101126"
          x1="111.939"
          y1="52.1777"
          x2="115.606"
          y2="59.6253"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint270_linear_1563_101126"
          x1="111.939"
          y1="52.668"
          x2="115.283"
          y2="59.4836"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint271_linear_1563_101126"
          x1="111.939"
          y1="53.1387"
          x2="114.986"
          y2="59.3299"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint272_linear_1563_101126"
          x1="111.939"
          y1="53.6104"
          x2="114.682"
          y2="59.1847"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint273_linear_1563_101126"
          x1="111.939"
          y1="54.1016"
          x2="114.365"
          y2="59.0365"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint274_linear_1563_101126"
          x1="111.939"
          y1="54.5713"
          x2="114.062"
          y2="58.8894"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint275_linear_1563_101126"
          x1="111.939"
          y1="55.0635"
          x2="113.745"
          y2="58.7421"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint276_linear_1563_101126"
          x1="111.939"
          y1="55.5332"
          x2="113.442"
          y2="58.595"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint277_linear_1563_101126"
          x1="111.939"
          y1="56.0049"
          x2="113.144"
          y2="58.4422"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint278_linear_1563_101126"
          x1="111.939"
          y1="56.4951"
          x2="112.822"
          y2="58.3005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint279_linear_1563_101126"
          x1="111.939"
          y1="56.9668"
          x2="112.524"
          y2="58.1479"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <linearGradient
          id="paint280_linear_1563_101126"
          x1="111.939"
          y1="57.4375"
          x2="112.221"
          y2="58.0017"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF478B" />
          <stop offset="1" stopColor="#FFBB54" />
        </linearGradient>
        <image
          id="image0_1563_101126"
          width="267"
          height="251"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
}
